<template>
     <div class="container-fluid">
        <!-- 전체 화면 로딩 오버레이 -->
        <div v-if="isDataLoading" class="loading-overlay">
            <div class="loading-content">
                <img :src="require('../../../assets/images/small/spinner.gif')" alt="Loading...">
                <p class="mt-3">데이터를 불러오는 중입니다...</p>
                <p class="text-muted small">{{ loadingProgress }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between mb-4">
                    <div>
                        <h4 class="mb-3">{{title}}</h4>
                        <p class="mb-0">{{desc1}}<br> {{desc2}}</p>
                        <p v-b-modal.modal-3 variant="link" class="mb-0"><u>발주서내역 수집 방법</u></p>
                            <b-modal id="modal-3" size="xl" title="판매내역 수집 방법" ok-title="Save Changes" cancel-title="Close">
                                <p><a href="https://chrome.google.com/webstore/detail/couplus/fdfjeigdbhekohnmjbggdcjomicdcjbp?hl=ko&authuser=0" target="_blank"><u>구글웹스토어</u></a>에 접속해서 "COUPLUS"를 다운받은 후 <b style="color:red"><u>"Supplier"에 로그인한 상태에서</u></b> 발주서 수집 버튼을 클릭해주세요. 발주서 수집이 끝날때까지 창을 닫거나 조정하시면 안됩니다.</p>
                                <img  style="max-width:100%;" :src="require('../../../assets/images/small/extension_polist.png')">
                            </b-modal>
                    </div>
                </div>

                
                <!-- 검색 카드 (컴팩트) -->
                <div class="card shadow-sm mb-2">
                    <div class="card-body py-2 px-3">
                        <!-- 1행: 기간 + 날짜범위 + 뷰모드 -->
                        <div class="d-flex align-items-center flex-wrap mb-2" style="gap: 8px;">
                            <!-- 기간 버튼 -->
                            <div class="btn-group btn-group-sm" role="group">
                                <button type="button" :class="['btn btn-sm', selectdate === 'today' ? 'btn-primary' : 'btn-outline-secondary']"
                                    @click="selectdate = 'today'; changedate()">오늘</button>
                                <button type="button" :class="['btn btn-sm', selectdate === 'week' ? 'btn-primary' : 'btn-outline-secondary']"
                                    @click="selectdate = 'week'; changedate()">7일</button>
                                <button type="button" :class="['btn btn-sm', selectdate === 'month' ? 'btn-primary' : 'btn-outline-secondary']"
                                    @click="selectdate = 'month'; changedate()">1개월</button>
                            </div>

                            <!-- 날짜 유형 -->
                            <select class="form-control form-control-sm" style="width: 90px;" v-model="selectoption">
                                <option>발주일</option>
                                <option>입고예정일</option>
                            </select>

                            <!-- 날짜 범위 -->
                            <div class="d-flex align-items-center" style="gap: 4px;">
                                <b-form-datepicker id="datepicker-start" size="sm" v-model="startdate"
                                    placeholder="시작일" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                    style="width: 140px;">
                                </b-form-datepicker>
                                <span class="text-muted">~</span>
                                <b-form-datepicker id="datepicker-end" size="sm" v-model="enddate"
                                    placeholder="종료일" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                    style="width: 140px;">
                                </b-form-datepicker>
                            </div>

                            <div class="ml-auto"></div>

                            <!-- 뷰 모드 스위칭 -->
                            <div class="btn-group btn-group-sm" role="group">
                                <button type="button" :class="['btn btn-sm', viewMode === 'po' ? 'btn-info' : 'btn-outline-info']"
                                    @click="switchViewMode('po')">
                                    <i class="ri-file-list-3-line"></i> 발주서
                                </button>
                                <button type="button" :class="['btn btn-sm', viewMode === 'sku' ? 'btn-info' : 'btn-outline-info']"
                                    @click="switchViewMode('sku')">
                                    <i class="ri-bar-chart-box-line"></i> SKU
                                </button>
                            </div>
                        </div>

                        <!-- 2행: 검색 필터 + 검색 버튼 -->
                        <div class="d-flex align-items-center flex-wrap" style="gap: 8px;">
                            <input type="text" class="form-control form-control-sm" style="width: 130px;" placeholder="발주번호" v-model="발주번호">
                            <input type="text" class="form-control form-control-sm" style="width: 130px;" placeholder="SKU ID" v-model="SKUID">
                            <input type="text" class="form-control form-control-sm" style="width: 130px;" placeholder="바코드" v-model="바코드">

                            <button type="button" class="btn btn-primary btn-sm" @click="handleSearch" :disabled="showspinner">
                                <i class="ri-search-line"></i> 검색
                            </button>
                            <img v-if="showspinner" style="width: 24px; height: 24px;" :src="require('../../../assets/images/small/spinner.gif')">
                        </div>
                    </div>
                </div>

                <div class="col-lg-12" v-if="showlist">
                    <!-- 발주서 기준 통계 -->
                    <div v-if="viewMode === 'po'" class="mb-2">
                        <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
                            <span class="badge bg-primary px-3 py-2" style="font-size: 0.9rem;">
                                총 발주금액: {{ totalpo.toLocaleString() }}원
                            </span>
                            <span class="badge bg-secondary px-3 py-2" style="font-size: 0.9rem;">
                                발주취소금액: {{ totalcancel.toLocaleString() }}원
                            </span>
                            <span class="badge bg-success px-3 py-2" style="font-size: 0.9rem;">
                                발주매출: {{ (totalpo - totalcancel).toLocaleString() }}원
                            </span>
                            <span class="badge bg-info px-3 py-2" style="font-size: 0.9rem;">
                                발주(수익) {{ mototal.toLocaleString() }}개({{ orderProfit.toLocaleString() }}원)
                            </span>
                            <span class="badge bg-warning text-dark px-3 py-2" style="font-size: 0.9rem;">
                                확정(수익) {{ moconfirm.toLocaleString() }}개({{ confirmProfit.toLocaleString() }}원)
                            </span>
                            <span class="badge bg-primary px-3 py-2" style="font-size: 0.9rem;">
                                입고(수익) {{ moReceivedQty.toLocaleString() }}개({{ receivedProfit.toLocaleString() }}원)
                            </span>
                            <span v-if="missingImportPriceCount > 0" class="badge bg-danger px-3 py-2" style="font-size: 0.85rem; cursor: pointer;" @click="$router.push({name: 'product.rocketProductManagement'})">
                                ⚠ 매입가 미입력 {{ missingImportPriceCount }}건 → 상품관리
                            </span>

                            <!-- 발주번호 필터 -->
                            <v-autocomplete
                                v-model="selectedPoFilter"
                                :items="poFilterOptions"
                                label="발주번호 선택"
                                dense
                                outlined
                                hide-details
                                clearable
                                style="max-width: 180px;"
                                class="filter-autocomplete"
                                @change="applyPoFilter"
                            ></v-autocomplete>
                        </div>

                        <!-- 필터 버튼 -->
                        <div class="d-flex flex-wrap mt-2" style="gap: 6px;">
                            <b-button size="sm" variant="outline-primary" @click="showmototal">
                                전체발주 <b-badge variant="primary">{{ mototal }}</b-badge>
                            </b-button>
                            <b-button size="sm" variant="outline-warning" @click="showmoconfirm">
                                발주확정 <b-badge variant="warning">{{ moconfirm }}</b-badge>
                            </b-button>
                            <b-button size="sm" variant="outline-danger" @click="showmocancel">
                                발주취소 <b-badge variant="danger">{{ mocancel }}</b-badge>
                            </b-button>
                            <b-button size="sm" variant="outline-success" @click="showmosstock">
                                사입재고 <b-badge variant="success">{{ mosstock }}</b-badge>
                            </b-button>
                            <b-button size="sm" variant="outline-secondary" @click="minusprofitlist" v-b-tooltip.bottom="'공급가보다 낮은 500원 이하 발주서'">
                                마이너스발주 <b-badge variant="secondary">{{ minusprofit }}</b-badge>
                            </b-button>
                            <b-button size="sm" variant="outline-dark" class="ml-auto" @click="showChart = !showChart">
                                {{ showChart ? '▲ 차트 접기' : '▼ 일별 차트' }}
                            </b-button>
                        </div>
                        <b-collapse v-model="showChart" class="mt-2">
                            <div class="card">
                                <div class="card-body py-2">
                                    <ApexChart
                                        v-if="showChart && poChartOptions.series"
                                        element="po-daily-chart"
                                        :chartOption="poChartOptions"
                                    />
                                </div>
                            </div>
                        </b-collapse>
                    </div>

                    <!-- SKU 기준 통계 -->
                    <div v-if="viewMode === 'sku'" class="mb-2">
                        <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
                            <span class="badge bg-primary px-3 py-2" style="font-size: 0.9rem;">
                                발주금액: {{ skuTotalAmount.toLocaleString() }}원
                            </span>
                            <span class="badge bg-secondary px-3 py-2" style="font-size: 0.9rem;">
                                취소금액: {{ skuTotalCancelAmount.toLocaleString() }}원
                            </span>
                            <span class="badge bg-success px-3 py-2" style="font-size: 0.9rem;">
                                발주매출: {{ (skuTotalAmount - skuTotalCancelAmount).toLocaleString() }}원
                            </span>
                            <span class="badge bg-warning px-3 py-2" style="font-size: 0.9rem;">
                                수익: {{ skuTotalProfit.toLocaleString() }}원
                            </span>
                            <span class="badge bg-info px-3 py-2" style="font-size: 0.9rem;">
                                발주수량: {{ skuTotalQty.toLocaleString() }}개
                            </span>
                            <span class="badge bg-light text-dark px-3 py-2" style="font-size: 0.9rem;">
                                확정수량: {{ skuConfirmQty.toLocaleString() }}개
                            </span>
                            <span class="badge bg-info px-3 py-2" style="font-size: 0.9rem;">
                                {{ skuItems.length }}건
                            </span>

                            <!-- SKU ID 필터 -->
                            <v-autocomplete
                                v-model="selectedSkuFilter"
                                :items="skuFilterOptions"
                                label="SKU ID 선택"
                                dense
                                outlined
                                hide-details
                                clearable
                                style="max-width: 180px;"
                                class="filter-autocomplete"
                                @change="applySkuFilter"
                            ></v-autocomplete>
                        </div>
                    </div>
                </div>

            <div class="col-lg-12" v-if="showlist">
                <!-- 발주서 기준 테이블 (CDataTable) -->
                <div v-if="viewMode === 'po'" class="mb-3">
                    <CDataTable
                        storage-key="listcategory.1"
                        key="po-table"
                        :headers="poHeaders"
                        :items="polists"
                        :items-per-page="50"
                        itemKey="발주번호"
                        :height="'600px'"
                        v-model="selectedPoItems"
                        :show-select="false"
                        @click:row="openPoDetailModal">

                        <!-- 발주운송 슬롯 -->
                        <template v-slot:발주운송="{ item }">
                            <b-badge :variant="item.발주운송 === '쉽먼트' ? 'success' : 'secondary'">
                                {{ item.발주운송 }}
                            </b-badge>
                        </template>
                    </CDataTable>
                </div>

                <!-- SKU 기준 테이블 (CDataTable) -->
                <div v-if="viewMode === 'sku'" class="mb-3">
                    <CDataTable
                        storage-key="listcategory.2"
                        key="sku-table"
                        :headers="skuHeaders"
                        :items="skuItems"
                        :items-per-page="50"
                        itemKey="_id"
                        :height="'600px'"
                        v-model="selectedSkuItems"
                        :show-select="false">

                        <!-- 이미지 슬롯 -->
                        <template v-slot:IMGURL="{ item }">
                            <img :src="item.IMGURL" class="rounded" style="width: 40px; height: 40px; object-fit: cover;" alt="">
                        </template>
                    </CDataTable>
                </div>

                <!-- 발주 상세 모달 -->
                <b-modal
                    id="po-detail-modal"
                    size="xl"
                    scrollable
                    :title="selectedPoForModal ? `발주번호: ${selectedPoForModal.발주번호}` : '발주세부내역'"
                    ok-only
                    ok-title="닫기">
                    <div v-if="selectedPoForModal" class="table-responsive">
                        <table class="table table-sm table-striped">
                            <thead class="thead-light">
                                <tr>
                                    <th style="min-width:100px;">SKU ID</th>
                                    <th style="min-width:200px;">상품명</th>
                                    <th v-for="m in menupodetail" :key="m">{{ m }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(a, i) in selectedPoForModal.발주세부내역" :key="i" :style="styleobj(a)">
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <img :src="a.IMGURL" class="rounded mr-2" style="width: 50px; height: 50px; object-fit: cover;" alt="">
                                            <div>{{ a.SKUID }}</div>
                                        </div>
                                    </td>
                                    <td>{{ a['상품명'] }}</td>
                                    <td v-for="m in menupodetail" :key="m">{{ a[m] }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>
                <button type="button" class="btn btn-primary mr-2 mb-4" @click="downloadpolist">발주서 다운로드</button>
                <button type="button" class="btn btn-secondary mr-2 mb-4" @click="openreqpurchase">구매요청</button>
                <!-- <button type="button" class="btn btn-warning mr-2 mb-4" @click="totaldatesinit">발주 및 재고배치 확정</button>
                <button type="button" class="btn btn-success mr-2 mb-4" @click="arrangelist">발주 및 재고배치 확정내역</button> -->
                    <b-modal id="reqpurchase" size="xl" scrollable title="구매대행요청" ok-title="구매대행요청추가" cancel-title="취소" class="detail-modal" @ok="requestpurchase($event)">
                        <div class="mb-2 text-muted small">
                            총 {{ reqlists.length }}건 | 구매요청수량 합계: {{ reqlists.reduce((sum, item) => sum + (parseInt(item.구매요청수량) || 0), 0) }}개
                        </div>
                        <CDataTable
                            storage-key="listcategory.3"
                            :headers="reqHeaders"
                            :items="reqlists"
                            v-model="reqSelectedItems"
                            itemKey="reqKey"
                            :items-per-page="50"
                            :show-select="false"
                            :isPerPage="true"
                            :isColumn="false"
                            :isRadio="false"
                        >
                            <!-- 발주정보 슬롯 -->
                            <template v-slot:발주정보="{ item }">
                                <div class="text-center">
                                    <div>{{ item.발주번호 }}</div>
                                    <small class="text-muted">{{ item.발주센터 }}</small><br>
                                    <small class="text-muted">{{ item.입고예정일 }}</small>
                                </div>
                            </template>

                            <!-- SKU정보 슬롯 -->
                            <template v-slot:SKU정보="{ item }">
                                <div class="d-flex align-items-center">
                                    <img :src="item.IMGURL" class="img-fluid rounded avatar-50 mr-2" alt="image" loading="lazy">
                                    <div>
                                        <div class="text-truncate" style="max-width: 180px;">{{ item.상품명 }}</div>
                                        <small class="text-muted">{{ item.SKUID }}</small><br>
                                        <small class="text-muted">{{ item.바코드 }}</small>
                                    </div>
                                </div>
                            </template>

                            <!-- 구매요청수량 슬롯 -->
                            <template v-slot:구매요청수량="{ item }">
                                <input type="number" class="form-control form-control-sm text-center"
                                    v-model="item.구매요청수량" :min="0" style="width: 80px;">
                            </template>

                            <!-- 삭제 슬롯 -->
                            <template v-slot:삭제="{ item }">
                                <a class="badge bg-warning" href="javascript:void(0)"
                                    @click="deletereqitem(reqlists.indexOf(item))" title="삭제">
                                    <i class="ri-delete-bin-line mr-0"></i>
                                </a>
                            </template>
                        </CDataTable>
                    </b-modal>

                    <b-modal id="waitreqpurchase" size="sm"  hide-footer>
                        <div class="text-center">
                            구매요청 내역을 저장 중입니다. 잠시만 기다려 주세요.
                        </div>
                        <div class=text-center>
                            <img style="max-width:100%;" :src="require('../../../assets/images/small/spinner.gif')">
                        </div>
                        
                    </b-modal>


                                    <b-modal id="confirmmodal" size="sm" scrollable title="발주 및 재고배치 확정" ok-title="발주확정 양식 다운로드" cancel-title="닫기" class="detail-modal" @ok="downloadpoconfirm">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <h6 class="mt-2 mb-1">[ 예상박스수량 ]<small>&nbsp;&nbsp;&nbsp;※상품DB에 '1박스인입수량'을 업데이트하면 예상박스수량을 확인하실 수 있습니다.</small></h6>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-control-inline">
                                                    <p v-b-tooltip.bottom="'출고되는 최대박스 사이즈 : 기준박스부피에 따라 센터별 예상박스수량이 달라집니다.'">기준박스부피</p>
                                                    <label class="custom-control-label" for="customRadio24">가로(mm)</label>
                                                    <input type="number" class="form-control" placeholder="길이(mm)" v-model="stdlength" @change="changeboxvolume">
                                                    <label class="custom-control-label" for="customRadio24">세로(mm)</label>
                                                    <input type="number" class="form-control" placeholder="너비(mm)" v-model="stdwidth" @change="changeboxvolume">
                                                    <label class="custom-control-label" for="customRadio24">높이(mm)</label>
                                                    <input type="number" class="form-control" placeholder="높이(mm)" v-model="stdheight" @change="changeboxvolume">
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="table-responsive">
                                                    <table id="datatable" class="table data-table table-striped dataTable" >
                                                        <thead>
                                                            <tr class="ligth text-center">
                                                                <th rowspan="2">입고예정일</th>
                                                                <th rowspan="2" class="border-right">발주센터</th>
                                                                <th class="border-right">쉽먼트 박스수량<div>( 확정전 + 확정후 )</div></th>
                                                                <th>밀크런 박스수량<div>( 확정전 + 확정후 )</div></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-b-modal="modalmulti2(index)" class="text-center" v-for="(list,index) in boxlists" :key="index">
                                                                <td>{{list.입고예정일}}</td>
                                                                <td class="border-right">{{list.발주센터}}</td>
                                                                <td :class="list.쉽먼트박스수량 > 9 ? 'btn-secondary btn-lg text-white font-weight-bold' : ''">
                                                                    {{list.쉽먼트박스수량 == 0 ? '' : list.총박스수량?.toFixed(2)}}  ( {{list.쉽먼트박스수량_확정전 == 0 ? 0 : list.쉽먼트박스수량_확정전?.toFixed(2)}} + {{list.쉽먼트박스수량_확정후 == 0 ? 0 : list.쉽먼트박스수량_확정후?.toFixed(2)}} )
                                                                </td>
                                                                <td :class="list.밀크런박스수량 > 9 ? 'btn-secondary btn-lg text-white font-weight-bold' : ''">
                                                                    {{list.밀크런박스수량 == 0 ? '' : list.총박스수량?.toFixed(2)}}  ( {{list.밀크런박스수량_확정전 == 0 ? 0 : list.밀크런박스수량_확정전?.toFixed(2)}} + {{list.밀크런박스수량_확정후 == 0 ? 0 : list.밀크런박스수량_확정후?.toFixed(2)}} )
                                                                </td>

                                            <b-modal :id="'modal-multi-2'+index" title="발주상세내역" ok-title="저장" cancel-title="취소" @cancel="initpolist(list.boxdetail)">
                                                <div class="col-md-12">
                                                    <h6 class="mt-2 mb-1">[ 발주확정 기준 ]</h6>              
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="customRadio24" name="customRadio-3" class="custom-control-input" v-model="list.confirmpo" value="all">
                                                        <label class="custom-control-label" for="customRadio24">전체</label>
                                                    </div>
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="customRadio22" name="customRadio-3" class="custom-control-input" v-model="list.confirmpo" value="stockkr">
                                                        <label class="custom-control-label" for="customRadio22">국내재고</label>
                                                    </div>
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="customRadio23" name="customRadio-3" class="custom-control-input" v-model="list.confirmpo" value="stocktotal">
                                                        <label class="custom-control-label" for="customRadio23">국내재고 + 해외재고</label>
                                                    </div>
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="customRadio21" name="customRadio-3" class="custom-control-input" v-model="list.confirmpo" value="total">
                                                        <label class="custom-control-label" for="customRadio21">국내재고 + 해외재고 + 구매재고</label>
                                                    </div>
                                                </div>

                                                <button type="button" class="btn btn-success mr-2 mb-4" @click="downloadstocklists">엑셀다운로드</button>
                                                <button type="button" class="btn btn-secondary mr-2 mb-4" @click="changeinfo(list.boxdetail)">변경</button>
                                                <!-- <button type="button" class="btn btn-primary mr-2 mb-4" @click="deleteitem">삭제</button> -->
                                                <!-- <button type="button" class="btn btn-secondary mr-2 mb-4" @click="changeshipment">쉽먼트 ↔ 밀크런</button> -->
                                                <button type="button" class="btn btn-primary mr-2 mb-4" @click="reqpurchase">구매대행요청</button>
                                                <!-- <button type="button" class="btn btn-secondary mr-2 mb-4" @click="confirmarrange">배치확정</button> -->
                                                <!-- <button type="button" class="btn btn-success mr-2 mb-4" @click="downloadconfirmpo">발주확정 다운로드</button> -->

                                                <tab-nav :tabs="true" id="myTab-1">
                                                    <tab-nav-items :active="true" id="shipment-tab" ariaControls="shipment" role="tab" :ariaSelected="true" title="쉽먼트" />
                                                    <tab-nav-items :active="false" id="milkrun-tab" ariaControls="milkrun" role="tab" :ariaSelected="false" title="밀크런/트럭" />
                                                </tab-nav>
                                                
                                                <tab-content id="myTabContent">
                                                    <tab-content-item :active="true" id="shipment" aria-labelled-by="shipment-tab">
                                                        <div class="card">
                                                            <div class="table-responsive" style="overflow-y:auto">
                                                                <table id="datatable" class="table data-table table-striped dataTable">
                                                                    <thead>
                                                                        <tr class="ligth ligth-data">
                                                                            <th>
                                                                                <div class="checkbox d-inline-block">
                                                                                    <input type="checkbox" class="checkbox-input" id="checkbox1" @change="checkallbox(list,'shipment')" v-model="list.shipmentcheck">
                                                                                    <label for="checkbox1" class="mb-0"></label>
                                                                                </div>
                                                                            </th>
                                                                            <!-- <th>발주운송</th> -->
                                                                            <th style="font-size:90%">입고예정일</th>
                                                                            <th style="font-size:90%">발주센터</th>
                                                                            <th style="font-size:90%">발주번호</th>
                                                                            <th style="font-size:90%">발주상태</th>
                                                                            <th style="font-size:90%">발주운송</th>

                                                                            <th style="font-size:90%">상품정보</th>
                                                                            <th style="font-size:90%">발주수량</th>
                                                                            <th style="font-size:90%">확정수량</th>

                                                                            <th style="font-size:90%">국내재고</th>
                                                                            <th style="font-size:90%">해외재고</th>
                                                                            <th style="font-size:90%">구매재고</th>

                                                                            <th style="font-size:90%">부피대비매출</th>
                                                                            <th style="font-size:90%">1박스인입수량</th>
                                                                            <th style="font-size:90%">누적박스수량</th>
                                                                            <th style="font-size:90%">배치박스번호</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(stocklist,idx) in list.boxdetail" :key="idx">
                                                                            <td>
                                                                                <div class="checkbox d-inline-block">
                                                                                    <input type="checkbox" class="checkbox-input" id="checkbox2" v-model="stocklist.checked">
                                                                                    <label for="checkbox2" class="mb-0"></label>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{stocklist.입고예정일}}</td>
                                                                            <td>{{stocklist.발주센터}}</td>
                                                                            <td>{{stocklist.발주번호}}</td>
                                                                            <td>{{stocklist.발주상태}}</td>
                                                                            <td>
                                                                                <div :class="stocklist.발주운송 == '쉽먼트' ? 'badge bg-success text-wrap mr-2 fw-bold' : 'badge bg-secondary text-wrap mr-2 fw-bold'">
                                                                                    {{stocklist.발주운송}}
                                                                                </div>
                                                                            </td>

                                                                            <td style="min-width:300px;font-size:80%;">
                                                                                <div class="d-flex align-items-center">
                                                                                        <img :src="stocklist.등록이미지" class="img-fluid rounded avatar-80 mr-3" alt="image">
                                                                                        <div>
                                                                                        {{stocklist.상품명}}
                                                                                        <p class="mb-0"><small>{{stocklist.바코드}}</small></p>
                                                                                        <p class="mb-0"><small>{{stocklist.SKUID}}</small></p>
                                                                                        </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{stocklist.발주수량}}</td>
                                                                            <td>{{stocklist.확정수량}}</td>

                                                                            <td>{{stocklist.국내재고수량 == 0 ? '' : stocklist.국내재고수량}}</td>
                                                                            <td>{{stocklist.해외재고수량 == 0 ? '' : stocklist.해외재고수량}}</td>
                                                                            <td>{{stocklist.구매재고수량 == 0 ? '' : stocklist.구매재고수량}}</td>

                                                                            <td>{{stocklist.부피대비수익률 == 0 ? '' : stocklist.부피대비수익률.toLocaleString('ko-KR')}}</td>
                                                                            <td @click="stocklist.showchangedb = false">
                                                                                <div v-if="stocklist.showchangedb">
                                                                                    {{stocklist['1박스인입수량'] == 0 ? '' : stocklist['1박스인입수량']}}
                                                                                </div>
                                                                                <div v-else>
                                                                                    <div class="form-group">
                                                                                        <input type="number" class="form-control" placeholder="1박스인입수량" v-model="stocklist['1박스인입수량']" @change="changeboxqty(stocklist)" @keyup.enter="stocklist.showchangedb = !stocklist.showchangedb">
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{stocklist.누적박스수량 == 0 ? '' : stocklist.누적박스수량?.toFixed(2)}}</td>
                                                                            <td>{{stocklist.출고박스번호 == 0 ? '' : stocklist.출고박스번호}}</td>

                                                                                        <b-modal id="modal-multi-3" title="변경" ok-only>
                                                                                            <div class="row">
                                                                                                <div class="col-md-12">
                                                                                                    <h6 class="mt-4 mb-1">[ 쉽먼트 / 밀크런]</h6>              
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <div class="custom-control custom-radio custom-control-inline">
                                                                                                        <input type="radio" id="customRadio25" name="customRadio-4" class="custom-control-input" v-model="stocklist.logistics" value="쉽먼트">
                                                                                                        <label class="custom-control-label" for="customRadio25">쉽먼트</label>
                                                                                                    </div>
                                                                                                    <div class="custom-control custom-radio custom-control-inline">
                                                                                                        <input type="radio" id="customRadio26" name="customRadio-4" class="custom-control-input" v-model="stocklist.logistics" value="밀크런">
                                                                                                        <label class="custom-control-label" for="customRadio26">밀크런</label>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <h6 class="mt-4 mb-1">[ 납품부족 사유 ]</h6>
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <div class="input-group mb-4">
                                                                                                        <input type="text" class="form-control" placeholder="납품부족사유선택" aria-label="" v-model="stocklist.reason" style="text-align:center;">
                                                                                                        <div class="input-group-append">
                                                                                                            <b-dropdown class="my-class" variant="primary" type="button" text="">
                                                                                                                <b-dropdown-item @click="reasonchange(b)" v-for="b,j in reasons" :key="j">{{b}}</b-dropdown-item>
                                                                                                            </b-dropdown>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-2 mt-4">
                                                                                                    <div class="form-group">
                                                                                                        <h6 for="confirmqty" class="mb-0">[ 확정수량 ]</h6>
                                                                                                        <input id="confirmqty" type="number" class="form-control" placeholder="확정수량" v-model="stocklist.확정수량">
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-2 mt-4">
                                                                                                    <div class="form-group">
                                                                                                        <h6 for="boxinput" class="mb-0">[ 1박스 인입수량 ]</h6>
                                                                                                        <input id="boxinput" type="number" class="form-control" placeholder="1박스인입수량" v-model="stocklist['1박스인입수량']">
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-2 mt-4">
                                                                                                    <div class="form-group">
                                                                                                        <h6 for="aboxnum" class="mb-0">[ 배치박스번호 ]</h6>
                                                                                                        <input id="aboxnum" type="number" class="form-control" placeholder="배치박스번호" v-model="stocklist.출고박스번호">
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-12 mt-4">
                                                                                                    <div class="custom-control custom-switch custom-control-inline">
                                                                                                        <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="rearrange">
                                                                                                        <label class="custom-control-label" for="customSwitch2">저장 후 전체박스 재 정렬</label>
                                                                                                    </div>          
                                                                                                </div>
                                                                                                                                        
                                                                                            </div>
                                                                                        </b-modal>



                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </tab-content-item>
                                                    <tab-content-item :active="false" id="milkrun" aria-labelled-by="milkrun-tab">
                                                        <div class="card">
                                                            <div class="table-responsive" style="overflow-y:auto">
                                                                <table id="datatable" class="table data-table table-striped dataTable">
                                                                    <thead>
                                                                        <tr class="ligth ligth-data">
                                                                            <th>
                                                                                <div class="checkbox d-inline-block">
                                                                                    <input type="checkbox" class="checkbox-input" id="checkbox1" @change="checkallbox(list,'milkrun')" v-model="list.milkruncheck">
                                                                                    <label for="checkbox1" class="mb-0"></label>
                                                                                </div>
                                                                            </th>
                                                                            <!-- <th>발주운송</th> -->
                                                                            <th style="font-size:90%">입고예정일</th>
                                                                            <th style="font-size:90%">발주센터</th>
                                                                            <th style="font-size:90%">발주번호</th>
                                                                            <th style="font-size:90%">발주상태</th>
                                                                            <th style="font-size:90%">발주운송</th>

                                                                            <th style="font-size:90%">상품정보</th>
                                                                            <th style="font-size:90%">발주수량</th>
                                                                            <th style="font-size:90%">확정수량</th>

                                                                            <th style="font-size:90%">국내재고</th>
                                                                            <th style="font-size:90%">해외재고</th>
                                                                            <th style="font-size:90%">구매재고</th>

                                                                            <th style="font-size:90%">부피대비매출</th>
                                                                            <th style="font-size:90%">1박스인입수량</th>
                                                                            <th style="font-size:90%">누적박스수량</th>
                                                                            <th style="font-size:90%">배치박스번호</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(stocklist,index) in list.milkrundetail" :key="index">
                                                                            <td>
                                                                                <div class="checkbox d-inline-block">
                                                                                    <input type="checkbox" class="checkbox-input" id="checkbox2" v-model="stocklist.checked">
                                                                                    <label for="checkbox2" class="mb-0"></label>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{stocklist.입고예정일}}</td>
                                                                            <td>{{stocklist.발주센터}}</td>
                                                                            <td>{{stocklist.발주번호}}</td>
                                                                            <td>{{stocklist.발주상태}}</td>
                                                                            <td>
                                                                                <div :class="stocklist.발주운송 == '쉽먼트' ? 'badge bg-success text-wrap mr-2 fw-bold' : 'badge bg-secondary text-wrap mr-2 fw-bold'">
                                                                                    {{stocklist.발주운송}}
                                                                                </div>
                                                                            </td>

                                                                            <td style="min-width:300px;font-size:80%;">
                                                                                <div class="d-flex align-items-center">
                                                                                        <img :src="stocklist.등록이미지" class="img-fluid rounded avatar-80 mr-3" alt="image">
                                                                                        <div>
                                                                                        {{stocklist.상품명}}
                                                                                        <p class="mb-0"><small>{{stocklist.바코드}}</small></p>
                                                                                        <p class="mb-0"><small>{{stocklist.SKUID}}</small></p>
                                                                                        </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{stocklist.발주수량}}</td>
                                                                            <td>{{stocklist.확정수량}}</td>

                                                                            <td>{{stocklist.국내재고수량 == 0 ? '' : stocklist.국내재고수량}}</td>
                                                                            <td>{{stocklist.해외재고수량 == 0 ? '' : stocklist.해외재고수량}}</td>
                                                                            <td>{{stocklist.구매재고수량 == 0 ? '' : stocklist.구매재고수량}}</td>

                                                                            <td>{{stocklist.부피대비수익률 == 0 ? '' : stocklist.부피대비수익률.toLocaleString('ko-KR')}}</td>
                                                                            <td @click="stocklist.showchangedb = false">
                                                                                <div v-if="stocklist.showchangedb">
                                                                                    {{stocklist['1박스인입수량'] == 0 ? '' : stocklist['1박스인입수량']}}
                                                                                </div>
                                                                                <div v-else>
                                                                                    <div class="form-group">
                                                                                        <input type="number" class="form-control" placeholder="1박스인입수량" v-model="stocklist['1박스인입수량']" @change="changeboxqty(stocklist)" @keyup.enter="stocklist.showchangedb = !stocklist.showchangedb">
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{stocklist.누적박스수량 == 0 ? '' : stocklist.누적박스수량?.toFixed(2)}}</td>
                                                                            <td>{{stocklist.출고박스번호 == 0 ? '' : stocklist.출고박스번호}}</td>


                                                                                        <b-modal id="modal-multi-3" title="변경" ok-only>
                                                                                            <div class="row">
                                                                                                <div class="col-md-12">
                                                                                                    <h6 class="mt-4 mb-1">[ 쉽먼트 / 밀크런]</h6>              
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <div class="custom-control custom-radio custom-control-inline">
                                                                                                        <input type="radio" id="customRadio25" name="customRadio-4" class="custom-control-input" v-model="stocklist.logistics" value="쉽먼트">
                                                                                                        <label class="custom-control-label" for="customRadio25">쉽먼트</label>
                                                                                                    </div>
                                                                                                    <div class="custom-control custom-radio custom-control-inline">
                                                                                                        <input type="radio" id="customRadio26" name="customRadio-4" class="custom-control-input" v-model="stocklist.logistics" value="밀크런">
                                                                                                        <label class="custom-control-label" for="customRadio26">밀크런</label>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <h6 class="mt-4 mb-1">[ 납품부족 사유 ]</h6>
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <div class="input-group mb-4">
                                                                                                        <input type="text" class="form-control" placeholder="납품부족사유선택" aria-label="" v-model="stocklist.reason" style="text-align:center;">
                                                                                                        <div class="input-group-append">
                                                                                                            <b-dropdown class="my-class" variant="primary" type="button" text="">
                                                                                                                <b-dropdown-item @click="reasonchange(b)" v-for="b,j in reasons" :key="j">{{b}}</b-dropdown-item>
                                                                                                            </b-dropdown>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-2 mt-4">
                                                                                                    <div class="form-group">
                                                                                                        <h6 for="confirmqty" class="mb-0">[ 확정수량 ]</h6>
                                                                                                        <input id="confirmqty" type="number" class="form-control" placeholder="확정수량" v-model="stocklist.확정수량">
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-2 mt-4">
                                                                                                    <div class="form-group">
                                                                                                        <h6 for="boxinput" class="mb-0">[ 1박스 인입수량 ]</h6>
                                                                                                        <input id="boxinput" type="number" class="form-control" placeholder="1박스인입수량" v-model="stocklist['1박스인입수량']">
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-2 mt-4">
                                                                                                    <div class="form-group">
                                                                                                        <h6 for="aboxnum" class="mb-0">[ 배치박스번호 ]</h6>
                                                                                                        <input id="aboxnum" type="number" class="form-control" placeholder="배치박스번호" v-model="stocklist.출고박스번호">
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-12 mt-4">
                                                                                                    <div class="custom-control custom-switch custom-control-inline">
                                                                                                        <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="rearrange">
                                                                                                        <label class="custom-control-label" for="customSwitch2">저장 후 전체박스 재 정렬</label>
                                                                                                    </div>          
                                                                                                </div>
                                                                                                                                        
                                                                                            </div>
                                                                                        </b-modal>



                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </tab-content-item>
                                                </tab-content>

                                               
                                                
                                            </b-modal>




                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div> 
                                            </div>
                                            
                                            

                                            
                                        </div>
                                                                                                                                                                                                                                                                                   
                                    </b-modal>
            </div>



            </div>









            
        </div>
        <!-- Page end  -->
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import CDataTable from "@/components/common/CDataTable";
import ApexChart from "@/components/charts/ApexChart";

export default {
    name:'listproduct',
    components: {
        CDataTable,
        ApexChart
    },
    data(){
        return{
            reqlists:[],
            reqSelectedItems: [], // 구매요청 모달 선택 항목

            // 구매요청 모달 헤더
            reqHeaders: [
                { text: '발주정보', value: '발주정보', align: 'center', width: 100, isSlot: true },
                { text: 'SKU정보', value: 'SKU정보', align: 'left', width: 250, isSlot: true },
                { text: '발주', value: '발주수량', align: 'center', width: 50 },
                { text: '확정', value: '확정수량', align: 'center', width: 50 },
                { text: '사입', value: '사입재고수량', align: 'center', width: 50 },
                { text: '국내', value: '국내재고', align: 'center', width: 50 },
                { text: '해외', value: '해외재고', align: 'center', width: 50 },
                { text: '필요', value: '구매필요수량', align: 'center', width: 50 },
                { text: '구매요청수량', value: '구매요청수량', align: 'center', width: 100, isSlot: true },
                { text: '삭제', value: '삭제', align: 'center', width: 50, isSlot: true },
            ],

            // 뷰 모드: 'po' = 발주서 기준, 'sku' = SKU 기준
            viewMode: 'po',

            // 발주서 기준 테이블 헤더
            poHeaders: [
                { text: '발주번호', value: '발주번호', align: 'center', width: 100 },
                { text: '발주상태', value: '발주상태', align: 'center', width: 85 },
                { text: '발주일시', value: '발주일시', align: 'center', width: 95 },
                { text: '발주운송', value: '발주운송', align: 'center', width: 65, isSlot: true },
                { text: '첫SKU명', value: '첫SKU명', align: 'left', width: 170 },
                { text: '발주', value: '발주수량', align: 'center', width: 55 },
                { text: '확정', value: '확정수량', align: 'center', width: 55 },
                { text: '발주센터', value: '발주센터', align: 'center', width: 85 },
                { text: '입고예정일', value: '입고예정일', align: 'center', width: 90 },
                { text: '금액', value: '금액', align: 'right', width: 85 },
                { text: '수익', value: '수익', align: 'right', width: 85 },
            ],

            // SKU 기준 테이블 헤더
            skuHeaders: [
                { text: '이미지', value: 'IMGURL', align: 'center', width: 50, isSlot: true },
                { text: 'SKU ID', value: 'SKUID', align: 'center', width: 90 },
                { text: '바코드', value: '바코드', align: 'center', width: 110 },
                { text: '발주번호', value: '발주번호', align: 'center', width: 95 },
                { text: '발주상태', value: '발주상태', align: 'center', width: 80 },
                { text: '발주일시', value: '발주일시', align: 'center', width: 90 },
                { text: '발주센터', value: '발주센터', align: 'center', width: 80 },
                { text: '입고예정일', value: '입고예정일', align: 'center', width: 90 },
                { text: '발주', value: '발주수량', align: 'center', width: 50 },
                { text: '확정', value: '확정수량', align: 'center', width: 50 },
                { text: '매입가', value: '매입가', align: 'right', width: 70 },
                { text: '금액', value: '금액', align: 'right', width: 75 },
                { text: '수익', value: '수익', align: 'right', width: 75 },
            ],

            // SKU 목록 (SKU 기준 보기용)
            skuItems: [],

            // 검색 모드: 'po' = 발주서 전체, 'sku' = 특정 SKU만
            searchMode: 'po',

            // SKU 기준 통계 (SKU 검색 시)
            skuTotalAmount: 0,
            skuTotalCancelAmount: 0,
            skuTotalQty: 0,
            skuConfirmQty: 0,
            skuTotalProfit: 0,

            // 필터 관련
            selectedPoFilter: null,  // 발주서 기준 필터
            selectedSkuFilter: null, // SKU 기준 필터

            // 선택된 행
            selectedPoItems: [],
            selectedSkuItems: [],

            // 상세 모달용 선택된 발주서
            selectedPoForModal: null,

            picked1: "radio1",
            showtable: true,
            showdetailtable: false,
            stdlength: 0,
            stdwidth: 0,
            stdheight: 0,

            milkrundetail: [],
            확정수량: '',
            박스인입수량 : '',
            배치박스번호: '',
            rearrange: true,


            title:"발주리스트",
            desc1:"발주서가 많은 경우 불러오는 데 다소 시간이 걸릴 수 있습니다.",
            desc2:"Chrome 웹스토어에서 COUPLUS Extension을 다운받은 후 발주서내역을 수집해주세요",
            link:{ name: 'product.addproduct'},
            linktext:"Add Product",
            selected: '',
            selectpo: '발주내역',
            selectoption: '발주일',
            picked: 'radio1',
            // checksstock: false,
            showspinner: false,
            isDataLoading: false,
            loadingProgress: '',

            status:'전체',

            selectdate: 'today',
            startdate: this.getTodaywith(),
            enddate: this.getTodaywith(),

            selection: "1",
            showlist:false,
            발주번호: '',
            SKUID: '',
            바코드: '',

            mototal: 0,
            moconfirm: 0,
            mostock: 0,
            moaddstock: 0,
            moastock: 0,
            mopstock: 0,
            morstock: 0,
            mosstock: 0,
            minusprofit: 0,
            mocancel: 0,
            moReceivedQty: 0,
            orderProfit: 0,
            confirmProfit: 0,
            receivedProfit: 0,
            missingImportPriceCount: 0,
            showChart: false,
            poChartOptions: {},

            confirmpo: 'all',

            menuint: ["발주상태","발주일시","발주운송","첫SKU명","발주수량","발주센터","입고예정일","금액"],
            menuDefault: ["발주상태","발주일시","발주운송","첫SKU명","발주수량","발주센터","입고예정일","금액"],
            menuDetail: ["발주상태","발주일시","발주운송","첫SKU명","발주수량","발주센터","입고예정일","금액","입고수량","입고시작일","입고종료일","예약상태"],
            //menuSales: ["바코드","구매링크","판매가격","판매링크","판매재고","판매상품명"],
            menupodetail: ["바코드","발주수량","확정수량","배치수량","구매필요수량","미배치재고수량","구매완료수량","회송예정수량","사입재고수량","매입가","공급가"],
            menureq:["발주수량","확정수량","사입재고수량","국내재고","해외재고","구매필요수량"],
            menureqth:["발주","확정","사입","국내","해외","필요"],
            polists: [],
            searchresult: [],

            boxdetail: [],
            boxdetailinit: [],

            boxlists: [],
            boxlistsinit: [],

            checkbox1:false,

            showboxdetail:false,
            totalpo: 0,
            totalcancel : 0,
            totalProfit: 0,
            importPriceMap: {},
            importPricesPromise: null,   // mounted에서 시작한 원가표 로딩 (검색이 먼저 오면 기다린다)

            reasons: [
                '제조사 생산중단 혹은 공급사 취급중단 - 제품 리뉴얼/모델 변경',
                '제조사 생산중단 혹은 공급사 취급중단 - 시장 단종',
                '제조사 생산중단 혹은 공급사 취급중단 - 사업자변경',
                '협력사 재고부족 - 수요예측 오류',
                '협력사 재고부족 - 생산캐파 부족 (설비라인/원자재/인력/휴무… 등등)',
                '협력사 재고부족 - 품질적 이슈 (유해물질 발견 / 유통기한 미달)',
                '협력사 재고부족 - 재고 할당정책',
                '협력사 재고부족 - 수입상품 입고지연 (선적/통관지연)',
                'FC 입고기준 미달로 회송',
                '가격 이슈 (Price) - 매입가 인하 협상 중',
                '가격 이슈 (Price) - 매입가 인상 협상 중',
                '가격 이슈 (Price) - 쿠팡 최저가 매칭',
                '최소발주량 변경 필요 (MOQ)',
                '쿠팡 요청 미납',
                '시즌상품으로 다음 시즌전까지 생산 혹은 취급중단',
            ],
            reason: '협력사 재고부족 - 수요예측 오류',
            logistics: '쉽먼트'
            //진행현황 : 
            //--> 주문전, 주문후중국택배이동, 배대지입고, 배대지작업중, (배대지작업중오류), 출고

        }
    },
    async mounted() {
        // 기존 settings 기반 초기화
        if (this.$store.state.settings && this.$store.state.settings[0]) {
            this.stdlength = parseInt(this.$store.state.settings[0].CreatePo_Boxsize_가로) || 0;
            this.stdwidth = parseInt(this.$store.state.settings[0].CreatePo_Boxsize_세로) || 0;
            this.stdheight = parseInt(this.$store.state.settings[0].CreatePo_Boxsize_높이) || 0;
        }

        // 원가표(매입가) 로딩. importPriceMap 은 Vuex가 아니라 이 컴포넌트 data 라
        // 화면에 들어올 때마다 새로 받아야 한다 — 다른 로딩과 달리 '비어 있으면' 조건을 못 건다.
        // 이게 비면 getImportPrice()가 늘 0을 돌려줘 발주/확정/입고 수익이 전부 0원이 되고
        // '매입가 미입력'이 발주 걸린 바코드 전량으로 찍힌다.
        // 아래 무거운 조회(Productdb/Stock/Purchase 각 1만건)와 나란히 돌리고 끝에서 기다린다.
        this.importPricesPromise = this.loadImportPrices();

        // 데이터 로딩 중 spinner 표시
        const needsLoading = this.$store.state.polist.length === 0 ||
                             this.$store.state.productdb.length === 0 ||
                             this.$store.state.stock.length === 0 ||
                             this.$store.state.purchase.length === 0;
        if(needsLoading) this.isDataLoading = true;

        // Vuex에 polist 데이터가 없으면 최근 3개월 데이터 로드
        if (this.$store.state.polist.length === 0) {
            await this.loadDefaultPolist();
        }

        // Productdb 컬렉션이 비어있으면 서버에서 가져오기
        //
        // ⚠ 한 번에 1만 건만 받으면 상품이 그보다 많은 회사에서 **뒷부분이 통째로 없는 채**
        //   화면이 돌아간다. 실측 CARTEM 18,681건 중 8,681건(전부 바코드 보유)이 빠져
        //   발주리스트 수익 3개가 0원으로 나왔다(대시보드는 전량을 읽어 481만원). 게다가
        //   판매구성수량을 찾는 곳들은 `.find(...).판매구성수량` 이라 못 찾으면 TypeError 다.
        //   ⇒ 1만을 넘으면 남은 쪽을 이어 받는다. 1만 이하인 회사는 요청 수가 그대로 1회다.
        if(this.$store.state.productdb.length === 0){
            try {
                const PAGE_SIZE = 10000;
                let page = 1, all = [], hasMore = true;
                while(hasMore){
                    const response = await axios.post('/api/getProductdb', { page, limit: PAGE_SIZE });
                    if(!response.data.success) break;
                    all = all.concat(response.data.data || []);
                    hasMore = response.data.pagination?.hasMore || false;
                    page++;
                }
                this.$store.commit('productdbupdate', all);
            } catch(e){
                console.log('Productdb 조회 실패:', e);
            }
        }

        // Stock 컬렉션이 비어있으면 서버에서 가져오기
        if(this.$store.state.stock.length === 0){
            try {
                const response = await axios.post('/api/getStock', { page: 1, limit: 10000 });
                if(response.data.success){
                    this.$store.commit('stockupdate', response.data.data);
                }
            } catch(e){
                console.log('Stock 조회 실패:', e);
            }
        }

        // Purchase 컬렉션이 비어있으면 서버에서 가져오기
        if(this.$store.state.purchase.length === 0){
            try {
                const response = await axios.post('/api/getPurchase', { page: 1, limit: 10000 });
                if(response.data.success){
                    this.$store.commit('purchaseupdate', response.data.data);
                }
            } catch(e){
                console.log('Purchase 조회 실패:', e);
            }
        }

        // 원가표를 다 받고 끝낸다. 목록이 이미 그려져 있으면 수익 3개를 다시 계산한다
        // (원가 없이 한 번 계산돼 0원으로 남아 있을 수 있다).
        await this.importPricesPromise;
        if (this.polists.length > 0) this.recalculateStats();

        if(needsLoading) this.isDataLoading = false;
    },
    computed: {
        // 발주번호 필터 옵션 (현재 검색된 데이터 기반)
        poFilterOptions() {
            if (!this.searchresult || this.searchresult.length === 0) {
                return [];
            }
            return [...new Set(this.searchresult.map(e => e.발주번호))].sort((a, b) => b - a);
        },
        // SKU ID 필터 옵션 (현재 검색된 데이터 기반)
        skuFilterOptions() {
            if (!this.searchresult || this.searchresult.length === 0) {
                return [];
            }
            const skuIds = new Set();
            this.searchresult.forEach(po => {
                if (po.발주세부내역) {
                    po.발주세부내역.forEach(sku => {
                        if (sku.SKUID) skuIds.add(String(sku.SKUID));
                    });
                }
            });
            return [...skuIds].sort();
        }
    },
    methods: {
        // 최근 3개월 날짜 계산
        getThreeMonthsAgo() {
            const date = new Date();
            date.setMonth(date.getMonth() - 3);
            const year = date.getFullYear();
            const month = ("0" + (1 + date.getMonth())).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            return year + "-" + month + "-" + day;
        },

        // 기본 polist 로드 (최근 3개월)
        async loadDefaultPolist() {
            this.isDataLoading = true;
            this.loadingProgress = '발주서 데이터 로딩 중...';

            try {
                const startdate = this.getThreeMonthsAgo();
                const enddate = this.getTodaywith();

                const res = await axios.post('/api/getPolist', {
                    startdate: startdate,
                    enddate: enddate,
                    selectoption: '발주일'
                });

                if (res.data.success) {
                    this.$store.commit('polistupdate', {
                        data: res.data.data,
                        dateRange: { startdate, enddate }
                    });
                    console.log('[listcategory] polist 로드 완료:', res.data.data.length, '개');
                } else {
                    console.error('[listcategory] polist 로드 실패:', res.data.message);
                }
            } catch (error) {
                console.error('[listcategory] polist 로드 오류:', error);
            } finally {
                this.isDataLoading = false;
                this.loadingProgress = '';
            }
        },

        // 검색 범위가 Vuex 데이터 범위 내인지 확인
        isSearchRangeWithinVuex() {
            const vuexRange = this.$store.state.polistDateRange;
            if (!vuexRange.startdate || !vuexRange.enddate) return false;

            const searchStart = this.timestamp(this.startdate);
            const searchEnd = this.timestamp(this.enddate);
            const vuexStart = this.timestamp(vuexRange.startdate);
            const vuexEnd = this.timestamp(vuexRange.enddate);

            return searchStart >= vuexStart && searchEnd <= vuexEnd;
        },

        // 발주번호 필터 적용
        applyPoFilter() {
            this.showlist = false;
            setTimeout(() => {
                if (!this.selectedPoFilter) {
                    // 필터 해제 - 전체 보기
                    this.polists = this.searchresult;
                } else {
                    // 발주번호로 필터링
                    this.polists = this.searchresult.filter(e => e.발주번호 === this.selectedPoFilter);
                }
                this.recalculateStats();
                this.showlist = true;
            }, 1);
        },

        // SKU ID 필터 적용
        applySkuFilter() {
            this.showlist = false;
            setTimeout(() => {
                if (!this.selectedSkuFilter) {
                    // 필터 해제 - 전체 SKU 보기
                    this.generateSkuItems();
                } else {
                    // 특정 SKU ID만 필터링
                    this.generateSkuItemsFiltered(this.selectedSkuFilter);
                }
                this.showlist = true;
            }, 1);
        },

        // 필터링된 SKU 아이템 생성
        generateSkuItemsFiltered(skuId) {
            const items = [];
            this.skuTotalAmount = 0;
            this.skuTotalCancelAmount = 0;
            this.skuTotalQty = 0;
            this.skuConfirmQty = 0;
            this.skuTotalProfit = 0;

            this.searchresult.forEach(po => {
                if (po.발주세부내역) {
                    po.발주세부내역.forEach(sku => {
                        if (String(sku.SKUID) === skuId) {
                            const 공급가숫자 = parseInt((sku.매입가 || '0').toString().replace(/,/g, '')) || 0;
                            const 금액숫자 = 공급가숫자 * sku.발주수량;

                            const 원가 = this.getImportPrice(sku.바코드);
                            const 단위수익 = (공급가숫자 > 0 && 원가 > 0) ? Math.round((공급가숫자 - 원가) * 10 / 11) : 0;
                            const 수익 = po.발주상태 !== '발주취소' ? 단위수익 * (sku.발주수량 || 0) : 0;

                            this.skuTotalQty += sku.발주수량 || 0;
                            this.skuConfirmQty += sku.확정수량 || 0;
                            if (po.발주상태 === '발주취소') {
                                this.skuTotalCancelAmount += 금액숫자;
                            } else {
                                this.skuTotalAmount += 금액숫자;
                                this.skuTotalProfit += 수익;
                            }

                            items.push({
                                발주번호: po.발주번호,
                                발주상태: po.발주상태,
                                발주일시: po.발주일시,
                                발주센터: po.발주센터,
                                입고예정일: po.입고예정일,
                                SKUID: sku.SKUID,
                                상품명: sku.상품명,
                                IMGURL: sku.IMGURL,
                                바코드: sku.바코드,
                                발주수량: sku.발주수량,
                                확정수량: sku.확정수량,
                                매입가: sku.매입가,
                                금액: 금액숫자.toLocaleString(),
                                수익: 수익 > 0 ? 수익.toLocaleString() : '-',
                                _id: `${po.발주번호}-${sku.SKUID}-${sku.바코드}`
                            });
                        }
                    });
                }
            });
            this.skuItems = items;
        },

        // 통계 재계산 (발주서 기준)
        recalculateStats() {
            this.totalpo = 0;
            this.totalcancel = 0;
            this.totalProfit = 0;
            this.mototal = 0;
            this.moconfirm = 0;
            this.mocancel = 0;
            this.mosstock = 0;
            this.minusprofit = 0;
            this.moReceivedQty = 0;
            this.orderProfit = 0;
            this.confirmProfit = 0;
            this.receivedProfit = 0;
            this.missingImportPriceCount = 0;
            const missingBarcodes = new Set();

            this.polists.forEach(e => {
                this.totalpo += parseInt(e.금액.replaceAll(',', '')) || 0;
                if (e.발주상태 === '발주취소') {
                    this.totalcancel += parseInt(e.금액.replaceAll(',', '')) || 0;
                }
                e.발주세부내역.forEach(ele => {
                    this.mototal += ele.발주수량 || 0;
                    this.moconfirm += ele.확정수량 || 0;
                    this.moReceivedQty += ele.입고수량 || 0;
                    if (ele.사입재고수량 > 0) this.mosstock++;
                    if (e.발주상태 !== '발주취소') {
                        const 공급가 = parseInt((ele.매입가 || '0').toString().replace(/,/g, '')) || 0;
                        const 원가 = this.getImportPrice(ele.바코드);
                        if (공급가 > 0 && 원가 === 0 && !missingBarcodes.has(ele.바코드)) {
                            missingBarcodes.add(ele.바코드);
                        }
                        if (공급가 > 0 && 원가 > 0) {
                            const 단위수익 = Math.round((공급가 - 원가) * 10 / 11);
                            this.orderProfit += 단위수익 * (ele.발주수량 || 0);
                            this.confirmProfit += 단위수익 * (ele.확정수량 || 0);
                            this.receivedProfit += 단위수익 * (ele.입고수량 || 0);
                        }
                    }
                });
                if (e.발주상태 === '발주취소') this.mocancel++;
            });
            this.totalProfit = this.orderProfit;
            this.missingImportPriceCount = missingBarcodes.size;
            this.buildDailyChart();
        },

        buildDailyChart() {
            const dailyMap = {};
            this.polists.forEach(e => {
                if (e.발주상태 === '발주취소') return;
                const date = (e.발주일시 || '').slice(0, 10);
                if (!date) return;
                if (!dailyMap[date]) {
                    dailyMap[date] = { 발주수: 0, 발주수량: 0, 발주수익: 0, 입고수량: 0, 입고수익: 0 };
                }
                dailyMap[date].발주수++;
                e.발주세부내역.forEach(ele => {
                    dailyMap[date].발주수량 += ele.발주수량 || 0;
                    dailyMap[date].입고수량 += ele.입고수량 || 0;
                    const 공급가 = parseInt((ele.매입가 || '0').toString().replace(/,/g, '')) || 0;
                    const 원가 = this.getImportPrice(ele.바코드);
                    if (공급가 > 0 && 원가 > 0) {
                        const 단위수익 = Math.round((공급가 - 원가) * 10 / 11);
                        dailyMap[date].발주수익 += 단위수익 * (ele.발주수량 || 0);
                        dailyMap[date].입고수익 += 단위수익 * (ele.입고수량 || 0);
                    }
                });
            });
            const dates = Object.keys(dailyMap).sort();
            this.poChartOptions = {
                chart: {
                    type: 'line',
                    height: 320,
                    toolbar: { show: true },
                    background: 'transparent'
                },
                series: [
                    { name: '발주수', type: 'column', data: dates.map(d => dailyMap[d].발주수) },
                    { name: '발주수량', type: 'column', data: dates.map(d => dailyMap[d].발주수량) },
                    { name: '입고수량', type: 'column', data: dates.map(d => dailyMap[d].입고수량) },
                    { name: '발주수익', type: 'line', data: dates.map(d => dailyMap[d].발주수익) },
                    { name: '입고수익', type: 'line', data: dates.map(d => dailyMap[d].입고수익) }
                ],
                xaxis: { categories: dates },
                yaxis: [
                    {
                        seriesName: '발주수',
                        title: { text: '수량' },
                        labels: { formatter: v => Math.round(v).toLocaleString() }
                    },
                    { seriesName: '발주수', show: false },
                    { seriesName: '발주수', show: false },
                    {
                        seriesName: '발주수익',
                        opposite: true,
                        title: { text: '수익 (원)' },
                        labels: { formatter: v => Math.round(v).toLocaleString() + '원' }
                    },
                    { seriesName: '발주수익', show: false }
                ],
                plotOptions: {
                    bar: { columnWidth: '50%' }
                },
                stroke: { width: [0, 0, 0, 3, 3], curve: 'smooth' },
                colors: ['#17a2b8', '#007bff', '#6f42c1', '#28a745', '#fd7e14'],
                tooltip: {
                    y: {
                        formatter: function(value, { seriesIndex }) {
                            if (seriesIndex >= 3) return Math.round(value).toLocaleString() + '원';
                            return Math.round(value).toLocaleString();
                        }
                    }
                },
                legend: { position: 'top' }
            };
        },

        // Chunk 기반 필수 데이터 로딩 (polist, productdb, stock)
        // ⚠ 지금은 부르는 곳이 없다. mounted가 chunk 대신 한 번에(limit 1만) 받는 방식으로 바뀌면서
        //   호출부만 빠지고 함수는 남았고, 그 바람에 원가표(loadImportPrices)까지 같이 죽어 있었다.
        //   원가표는 mounted에서 직접 부른다. 이 함수는 chunk 로딩이 다시 필요할 때 쓸 자리.
        async loadRequiredDataChunked() {
            // 병렬로 필요한 데이터 로딩
            const loadPromises = [];
            const loadingLabels = [];

            if (this.$store.state.polist.length === 0) {
                loadPromises.push(this.loadChunked('/api/getPolist', 'polistupdate', 'Polist'));
                loadingLabels.push('Polist');
            }
            if (this.$store.state.productdb.length === 0) {
                loadPromises.push(this.loadChunked('/api/getProductdb', 'productdbupdate', 'Productdb'));
                loadingLabels.push('Productdb');
            }
            if (this.$store.state.stock.length === 0) {
                loadPromises.push(this.loadChunked('/api/getStock', 'stockupdate', 'Stock'));
                loadingLabels.push('Stock');
            }

            // RocketPurchaseDB 매입가 데이터 로드
            loadPromises.push(this.loadImportPrices());

            if (loadPromises.length > 0) {
                this.loadingProgress = `${loadingLabels.join(', ')} 로딩 중...`;
                console.log('[listcategory] 필요 데이터 chunk 로딩 시작...');
                await Promise.all(loadPromises);
                console.log('[listcategory] 필요 데이터 로딩 완료');
            }
        },

        async loadImportPrices() {
            try {
                const res = await axios.post('/api/rocketpurchasedb/getImportPrices');
                if (res.data.success) {
                    this.importPriceMap = res.data.data || {};
                }
            } catch (e) {
                console.error('[listcategory] 매입가 로딩 오류:', e);
            }
        },

        // 바코드로 원가(매입가) 조회: 바코드 → productdb에서 vendorItemId 추출 → importPriceMap 조회
        getImportPrice(바코드) {
            const product = this.$store.state.productdb.find(p => p.바코드 === 바코드);
            if (!product || !product.판매링크) return 0;
            const match = product.판매링크.match(/vendorItemId=(\d+)/);
            if (!match) return 0;
            return this.importPriceMap[match[1]] || 0;
        },

        async loadChunked(apiUrl, mutationName, label) {
            const CHUNK_SIZE = 500;
            let page = 1;
            let allData = [];
            let hasMore = true;

            while (hasMore) {
                try {
                    const res = await axios.post(apiUrl, { page, limit: CHUNK_SIZE });
                    if (res.data.success && res.data.data) {
                        allData = allData.concat(res.data.data);
                        hasMore = res.data.pagination?.hasMore || false;
                        const total = res.data.pagination?.total || '?';
                        this.loadingProgress = `${label}: ${allData.length}/${total}개`;
                        console.log(`[listcategory] ${label} page ${page}: ${res.data.data.length}개 (총 ${allData.length}/${total})`);
                        page++;
                    } else {
                        hasMore = false;
                    }
                } catch (err) {
                    console.error(`[listcategory] ${label} 로딩 오류:`, err);
                    hasMore = false;
                }
            }

            this.$store.commit(mutationName, allData);
            console.log(`[listcategory] ${label} 로딩 완료: 총 ${allData.length}개`);
        },
        deletereqitem(i){
            this.reqlists = this.reqlists.slice(0,i).concat(this.reqlists.slice(i+1))
        },
        openreqpurchase(){
            this.reqlists = [];
            this.reqSelectedItems = [];
            let reqIndex = 0;
            this.polists.forEach(e => {
                if(!e.발주상태.includes('거래명세서') && !e.발주상태.includes('발주취소')){
                    e.발주세부내역.forEach(ele => {
                        var cloneobj = this.deepClone(ele);
                        cloneobj.발주번호 = e.발주번호;
                        cloneobj.발주센터 = e.발주센터;
                        cloneobj.입고예정일 = e.입고예정일;
                        cloneobj.구매요청수량 = cloneobj.구매필요수량;
                        cloneobj.reqKey = `${e.발주번호}_${ele.바코드}_${reqIndex++}`; // 고유 키 추가
                        this.reqlists.push(cloneobj)
                    })
                }
            })
            
            this.$bvModal.show('reqpurchase')
        },
        changeboxvolume(){
            console.log(this.stdlength + 'x' + this.stdwidth + 'x' + this.stdheight)
        },
        modalmulti2(index){
            return 'modal-multi-2' + index
        },
        reqpurchase(){
            //구매대행요청




        },
        savechangeinfo(){
            this.boxdetail.filter(e => e.checked).forEach(e => {
                e.발주운송 = this.logistics;
                if(this.확정수량){
                    e.확정수량 = this.확정수량;
                }
                if(this.박스인입수량){
                    e['1박스인입수량'] = this.박스인입수량;
                }
                if(this.배치박스번호){
                    e.출고박스번호 = this.배치박스번호;
                }
            })            
            if(this.rearrange){
                this.sortbox()
            }
            this.확정수량 = '';
            this.박스인입수량 = '';
            this.배치박스번호 = '';
        },
        changeshipment(){
            if(this.boxdetail.filter(e => e.checked).length == 0){
                alert('변경할 내역을 선택해 주세요')
                return
            }
            this.boxdetail.filter(e => e.checked).forEach(e => {
                if(e.발주운송 == '쉽먼트'){
                    e.발주운송 = '밀크런'
                } else {
                    e.발주운송 = '쉽먼트'
                }
            })
        },
        changeinfo(boxdetail){
            if(boxdetail.filter(e => e.checked).length == 0){
                alert('변경할 내역을 선택해 주세요')
                return
            }
            this.$bvModal.show('modal-multi-3')
        },
        deleteitem(){
            if(this.boxdetail.filter(e => e.checked).length == 0){
                alert('삭제할 내역을 선택해 주세요')
                return
            }
            if(confirm(this.boxdetail.filter(e => e.checked).length + '개의 내역을 삭제 하시겠습니까?')){
                var arr = [];
                this.boxdetail.filter(e => !e.checked).forEach(e => {
                    arr.push(this.deepClone(e))
                })
                this.boxdetail = arr;
            }
        },
        reasonchange(reason){
            this.reason = reason;
        },
        async requestpurchase($event){
            $event.preventDefault();
            var 요청건수 = this.reqlists.filter(e => parseInt(e.구매요청수량) > 0).length;
            var 요청수량 = this.reqlists.reduce((pv,cv) => {return pv + parseInt(cv.구매요청수량)},0);
            this.$bvModal.show('waitreqpurchase');
            if(confirm(요청건수 + '건(총수량:' + 요청수량 + '개)의 내역을 구매요청하시겠습니까?')){
                var arr = [];
                for(var i=0;i<this.reqlists.length;i++){
                    var e = this.reqlists[i];
                    var obj = await this.addlists(e);
                    arr.push(this.deepClone(obj));
                }
                await this.addreqlist(arr)
            }
        },
        async addreqlist(lists){
            console.log(lists)
            try{
                // 데이터를 10개씩 청크로 나누어 처리
                const chunkSize = 10;
                const chunks = [];
                for (let i = 0; i < lists.length; i += chunkSize) {
                    chunks.push(lists.slice(i, i + chunkSize));
                }

                console.log(`총 ${lists.length}개 항목을 ${chunks.length}개 청크로 나누어 처리합니다.`);

                // 각 청크를 순차적으로 처리
                for (let i = 0; i < chunks.length; i++) {
                    console.log(`청크 ${i + 1}/${chunks.length} 처리 중... (${chunks[i].length}개 항목)`);

                    const res = await axios.post('/api/reqpurchase/addreqlist', chunks[i]);
                    console.log(`청크 ${i + 1} 완료:`, res);

                    // 각 요청 사이에 100ms 지연
                    if (i < chunks.length - 1) {
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }
            }catch(e){
                console.log(e)
            }
            this.$bvModal.hide('waitreqpurchase');
            if(confirm('저장이 완료되었습니다. 구매요청메뉴로 이동하시겠습니까?')){
                this.$router.push({name:'purchase.reqpurchase'})
            }
            this.$bvModal.hide('reqpurchase');
        },
        async addlists(e){
            var ob = this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))
            var 발주 = this.polists.filter(ele => ele.발주번호 == e.발주번호);
            var poarr = [];
            if(발주.length > 0){
                var cloneobj = {};
                발주.forEach(e => {
                    if(!e.발주상태.includes('거래명세서') && !e.발주상태.includes('발주취소')){
                        e.발주세부내역.forEach(ele => {
                            if(ele.바코드 == ob.바코드){
                                cloneobj = this.deepClone(e);
                                cloneobj.sku수량 = parseInt(ele.확정수량);
                                poarr.push(this.deepClone(cloneobj))
                            }
                        })
                    }
                })
            }
            var obj = {
                checked : false,
                showspinner : false,
                SKUID : ob['SKU ID'],
                바코드 : ob.바코드 ? ob.바코드 : '',
                상품명 : ob.상품명,
                상품명init : '',
                진행현황 : '구매전',
                구매링크 : ob.구매링크 ? ob.구매링크 : undefined,
                구매링크init : ob.구매링크 ? ob.구매링크 : undefined,
                옵션1_중국어 : ob.옵션1_중국어 ? ob.옵션1_중국어 : undefined,
                옵션2_중국어 : ob.옵션2_중국어 ? ob.옵션2_중국어 : undefined,
                옵션이미지: ob.옵션이미지 ? ob.옵션이미지 : undefined,
                매칭상태 : ob.매칭상태 ? ob.매칭상태 : '매칭필요',
                상품매칭 : {
                    옵션1_중국어 : [],
                    옵션2_중국어 : [],
                },
                구매재고 : '',
                구매요청수량 : e.구매요청수량,
                판매구성수량: ob.판매구성수량 ? (ob.판매구성수량 == '단품' ? 1 : ob.판매구성수량) : 1,
                묶음구성여부 : ob.묶음구성여부 ? ob.묶음구성여부 : false,
                묶음구성수량 : ob.묶음구성수량 ? ob.묶음구성수량 : '',
                묶음대상바코드 : ob.묶음대상바코드 ? ob.묶음대상바코드 : '',
                신고영문명 : ob.신고영문명 ? ob.신고영문명 : '',
                신고가격 : ob['신고가격(USD)'] ? ob['신고가격(USD)'] : '',
                HSCODE : ob['HS-CODE'] ? ob['HS-CODE'] : '',
                재고동봉 : true,
                등록이미지 : ob.등록이미지,
                요청사항 : '요청등록',
                reqtype : '로켓배송',
                sizeX : ob.sizeX ? ob.sizeX : '',
                sizeY : ob.sizeY ? ob.sizeY : '',
                sizeZ : ob.sizeZ ? ob.sizeZ : '',
                weight : ob.weight ? ob.weight : '',
                요청내역 : {
                    default : true,
                    poarrange : true,

                    boxnumber : '',
                    한글표시사항 : true,
                    barcode : true,
                    sticker : false,
                    stamp : false,
                    tag : false,
                    reqcontent : '',
                    opp : false,
                    LDPE : false,
                    airpacking : false,
                    exportType : 'pallet',
                },
                한글표시사항 : {
                    제품명 : ob.상품명,
                    '수입원/판매원' : ob['수입원/판매원'],
                    제조원 : ob.제조원,
                    제조국 : ob.제조국,
                    내용량 : ob.내용량,
                    '원료명및성분명(재질)' : ob['원료명및성분명(재질)'],
                    상품유형 : ob.상품유형,
                    사용시주의사항 : ob.사용시주의사항,
                    사용기준 : ob.사용기준,
                },
                발주수량 : poarr[0].sku수량,
                polists : poarr,
                selectpo : e.발주번호,
            }
            var newObj = await this.confirmreq(obj);
            return newObj
        },
        async confirmreq(obj) {
            console.log(obj)
            if (!obj.구매링크) {
                obj.showspinner = false;
                return obj
            }
            obj.구매링크init = obj.구매링크;
            obj.매칭상태 = '매칭필요'
            var item = await this.getProductInfo(obj.구매링크);
            if (!item || !item.data || !item.data.result || !item.data.result[0] || !item.data.result[0].result) {
                obj.showspinner = false;
                obj.매칭상태 = '매칭필요';
                return obj;
            }
            item = item.data.result[0].result.result
            if (!item) {
                obj.showspinner = false;
                obj.매칭상태 = '매칭필요';
                return obj;
            }
            console.log(item)
            obj.item = item;

            let option1array = [];
            let option2array = [];

            if (item.productSkuInfos) {
                item.productSkuInfos.forEach((e) => {
                    if (!option1array.find(option => option.name === e.skuAttributes[0].value)) {
                        option1array.push({
                            name: e.skuAttributes[0].value,
                            imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
                        })
                    }

                    if (e.skuAttributes[1]) {
                        if (!option2array.find(option => option.name === e.skuAttributes[1].value)) {
                            option2array.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    } else {
                        option2array = []
                    }
                })
            }

            if (option1array.length === 0) {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = item.productSaleInfo.amountOnSale;
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.productImage.images[0];
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.productImage.images[0];
                obj.매칭상태 = '매칭완료'
            } else {
                var imgUrl = '';
                if (option2array.length == 0) {
                    imgUrl = option1array.find(e => e.name == obj.옵션1_중국어) ? imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : "";
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어).amountOnSale;
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : imgUrl;
                        obj.매칭상태 = '매칭완료'
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션2_중국어 = '';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                } else {
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : option1array.find(e => e.name == obj.옵션1_중국어).imageUrl;
                        if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                            obj.옵션2_중국어 = undefined;
                            obj.구매재고 = 0;
                        } else {
                            obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어 && f.skuAttributes[1].value == obj.옵션2_중국어)?.amountOnSale || 0;
                            imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : "");
                            obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : (option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : ""));
                            if(obj.구매재고 == 0){
                                obj.매칭상태 = '매칭필요'
                                obj.옵션1_중국어 = undefined;
                                obj.옵션2_중국어 = undefined;
                            } else {
                                obj.매칭상태 = '매칭완료'
                            }
                        }
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = option2array;
                    console.log(option1array)
                    console.log(option1array.find(e => e.name == obj.옵션1_중국어))
                    console.log(option2array)

                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                }

                if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
                    obj.등록이미지 = item.productImage.images[0];
                }
            }
            obj.showspinner = false;
            return obj
        },
        async getProductInfo(구매링크) {
            var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
            try {
                var res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }])
                return res
            } catch (e) {
                console.log('err821' + e);
                return false
            }
        },
        async changeboxqty(stocklist){
            var arr = [];
            arr.push(stocklist)
            axios.post('/api/listcategory/updateboxqty',arr)
			.then((res) => {
				if(res.data.요청결과 == "수정완료"){
                    this.$store.commit('updateboxqty',stocklist)
				} else {
                    alert('업데이트 실패(469)');
                    console.log(res.data)
                }
			})	
			.catch((e) => {alert("업데이트 실패(473)");console.log(e);})
        },
        clickdb(stocklist){
            stocklist.showchangedb = true;
        },
        downloadstocklists(){
            var arr = [];
            this.boxdetail.forEach(e => {
                arr.push(this.deepClone(e))
            })
            arr.forEach(e => {
                delete e.checked;
                delete e.showchangedb;
            })
            const workBook = XLSX.utils.book_new()
            const workSheet1 = XLSX.utils.json_to_sheet(arr)
            XLSX.utils.book_append_sheet(workBook, workSheet1, '재고세부내역')
            XLSX.writeFile(workBook, '재고세부내역.xlsx')
        },
        checkallbox(list,a){
            if(a == 'shipment'){
                if(list.shipmentcheck){
                    list.shipmentdetail.forEach(e => {
                        e.checked = true;
                    })
                } else {
                    list.shipmentdetail.forEach(e => {
                        e.checked = false;
                    })
                }
            } else {
                if(list.milkruncheck){
                    list.milkrundetail.forEach(e => {
                        e.checked = true;
                    })
                } else {
                    list.milkrundetail.forEach(e => {
                        e.checked = false;
                    })
                }                
            }
        },
        arrangelist(){
            this.totaldatesinit()
        },
        totaldatesinit2(){
            var arr = [];
            var obj = {}; // 입고예정일 / 발주센터 / 쉽먼트_확정전 / 쉽먼트_확정후 / 밀크런_확정전 / 밀크런_확정후 / boxdetail / milkrundetail
            this.boxlists = [];
            this.boxlistsinit = [];

            this.polists.forEach(e => {
                if(e.발주상태.includes('거래처확인요청') || e.발주상태.includes('발주확정')){
                    obj = {
                        입고예정일 : e.입고예정일,
                        발주센터 : e.발주센터,
                        발주번호 : e.발주번호,
                        발주세부내역 : e.발주세부내역,
                        발주상태 : e.발주상태,
                        발주운송 : e.발주운송
                    }
                    arr.push(obj)
                }
            })

            var stocks = [];
            var so = {}
            var stockfilter = this.$store.state.stock.filter(e => e.stockinfo == 'stock')
            stockfilter.forEach(e => {
                if(e.site == 'kr'){
                    if(stocks.length > 0 && stocks.filter(ele => ele.바코드 == e.바코드).length > 0){
                        stocks.find(ele => ele.바코드 == e.바코드).수량++
                    } else {
                        so = {
                            site : 'kr',
                            바코드 : e.바코드,
                            수량 : 1
                        }
                        stocks.push(so)
                    }
                } else {
                    if(stocks.length > 0 && stocks.filter(ele => ele.바코드 == e.바코드).length > 0){
                        stocks.find(ele => ele.바코드 == e.바코드).수량++
                    } else {
                        so = {
                            site : 'cn',
                            바코드 : e.바코드,
                            수량 : 1
                        }
                        stocks.push(so)
                    }
                }
            })

            var 주문수량 = 0;
            if(this.$store.state.purchase.length > 0){
                this.$store.state.purchase.filter(e => e.배송상태 != '입고완료').forEach(e => {
                    if(stocks.length > 0 && stocks.filter(ele => ele.site == 'po' && ele.바코드 == e.바코드).length > 0){
                        if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량){
                            if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량 == '단품' || parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량) == 1){
                                stocks.find(ele => ele.site == 'po' && ele.바코드 == e.바코드).수량 += e.주문수량;
                            } else {
                                stocks.find(ele => ele.site == 'po' && ele.바코드 == e.바코드).수량 += Math.floor(e.주문수량/parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량));
                            }
                        } else {
                            stocks.find(ele => ele.site == 'po' && ele.바코드 == e.바코드).수량 += e.주문수량;
                        }
                    } else {
                        if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량){
                            if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량 == '단품' || parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량) == 1){
                                주문수량 = e.주문수량;
                            } else {
                                주문수량 = Math.floor(e.주문수량/parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량));
                            }
                        } else {
                            주문수량 = e.주문수량;
                        }
                        so = {
                            site : 'po',
                            바코드 : e.바코드,
                            수량 : 주문수량
                        }
                        stocks.push(so)
                    }
                })
            }

            
            arr.sort(function(a,b){
                if (a.발주번호 < b.발주번호){
                    return -1;
                }
                if (a.발주번호 > b.발주번호){
                    return 1;
                }
                return 0;
            })
            arr.sort(function(a,b){
                if (a.발주센터 < b.발주센터){
                    return -1;
                }
                if (a.발주센터 > b.발주센터){
                    return 1;
                }
                return 0;
            })
            arr.sort(function(a,b){
                return new Date(a.입고예정일) - new Date(b.입고예정일);
            })
            

            


        },
        totaldatesinit(){
            var arr = [];
            var obj = {}; // 입고예정일 / 발주센터 / 총박스수량 / 국내재고박스수량 / 물류재고박스수량 / 구매박스수량 / 회송박스수량
            this.boxlists = [];
            this.boxlistsinit = [];
            //polist중 발주확정 안된 것들만 sorting
            this.polists.forEach(e => {
                if(e.발주상태.includes('거래처확인요청') || e.발주상태.includes('발주확정')){
                    obj = {
                        입고예정일 : e.입고예정일,
                        발주센터 : e.발주센터,
                        발주번호 : e.발주번호,
                        발주세부내역 : e.발주세부내역,
                        발주상태 : e.발주상태,
                        발주운송 : e.발주운송
                    }
                    arr.push(obj)
                }
            })
            var vol;

            var stocks = [];
            var so = {}
            var stockfilter = this.$store.state.stock.filter(e => e.stockinfo == 'stock')
            stockfilter.forEach(e => {
                if(e.site == 'kr'){
                    if(stocks.length > 0 && stocks.filter(ele => ele.바코드 == e.바코드).length > 0){
                        stocks.find(ele => ele.바코드 == e.바코드).수량++
                    } else {
                        so = {
                            site : 'kr',
                            바코드 : e.바코드,
                            수량 : 1
                        }
                        stocks.push(so)
                    }
                } else {
                    if(stocks.length > 0 && stocks.filter(ele => ele.바코드 == e.바코드).length > 0){
                        stocks.find(ele => ele.바코드 == e.바코드).수량++
                    } else {
                        so = {
                            site : 'cn',
                            바코드 : e.바코드,
                            수량 : 1
                        }
                        stocks.push(so)
                    }
                }
            })

            var 주문수량 = 0;
            if(this.$store.state.purchase.length > 0){
                this.$store.state.purchase.filter(e => e.배송상태 != '입고완료').forEach(e => {
                    if(stocks.length > 0 && stocks.filter(ele => ele.site == 'po' && ele.바코드 == e.바코드).length > 0){
                        if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드)?.판매구성수량){
                            if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량 == '단품' || parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량) == 1){
                                stocks.find(ele => ele.site == 'po' && ele.바코드 == e.바코드).수량 += e.주문수량;
                            } else {
                                stocks.find(ele => ele.site == 'po' && ele.바코드 == e.바코드).수량 += Math.floor(e.주문수량/parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량));
                            }
                        } else {
                            stocks.find(ele => ele.site == 'po' && ele.바코드 == e.바코드).수량 += e.주문수량;
                        }
                    } else {
                        if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드)?.판매구성수량){
                            if(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량 == '단품' || parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량) == 1){
                                주문수량 = e.주문수량;
                            } else {
                                주문수량 = Math.floor(e.주문수량/parseInt(this.$store.state.productdb.find(ele => ele.바코드 == e.바코드).판매구성수량));
                            }
                        } else {
                            주문수량 = e.주문수량;
                        }
                        so = {
                            site : 'po',
                            바코드 : e.바코드,
                            수량 : 주문수량
                        }
                        stocks.push(so)
                    }
                })
            }

            
            arr.sort(function(a,b){
                if (a.발주번호 < b.발주번호){
                    return -1;
                }
                if (a.발주번호 > b.발주번호){
                    return 1;
                }
                return 0;
            })
            arr.sort(function(a,b){
                if (a.발주센터 < b.발주센터){
                    return -1;
                }
                if (a.발주센터 > b.발주센터){
                    return 1;
                }
                return 0;
            })
            arr.sort(function(a,b){
                return new Date(a.입고예정일) - new Date(b.입고예정일);
            })


            // if(!arr.find(e => e.발주세부내역.find(ele => this.$store.state.productdb.find(element => element.바코드 == ele.바코드)['1박스인입수량']))){
            //     alert('상품별 박스수량 확인을 위해 상품 > 상품DB등록 > 다운로드 후 엑셀에서 "1박스인입수량"열을 먼저 업데이트 해주세요. 1박스인입수량이 업데이트되지 않은 상품은 예상박스수량에 포함되지 않습니다.')
            // }

            console.log(stocks) //재고
            console.log(arr) //발주서내역
            var cnt = 0;
            var krstock = 0;
            var pstock = 0;
            var cnstock = 0;
            var totalcnt = 0;

            //발주세부내역에 재고수량/재고박스수량 추가
            arr.forEach(e => {
                krstock = 0;
                cnstock = 0;
                pstock = 0;
                totalcnt = 0;
                // rstock = 0;
                e.발주세부내역.forEach(ele => {
                    cnt = parseInt(ele.확정수량)
                    ele.국내재고수량 = 0;
                    ele.해외재고수량 = 0;
                    ele.구매재고수량 = 0;
                    ele.국내재고박스수량 = 0;
                    ele.해외재고박스수량 = 0;
                    ele.구매재고박스수량 = 0;
                    ele.확정박스수량 = 0;
                    if(this.$store.state.productdb && this.$store.state.productdb.find(element => element.바코드 == ele.바코드)['1박스인입수량']){
                        vol = 1/this.$store.state.productdb.find(element => element.바코드 == ele.바코드)['1박스인입수량']
                        ele['1박스인입수량'] = this.$store.state.productdb.find(element => element.바코드 == ele.바코드)['1박스인입수량'];
                    } else {
                        vol = 0
                        ele['1박스인입수량'] = 0;
                    }
                    if(this.$store.state.productdb && this.$store.state.productdb.find(element => element.바코드 == ele.바코드) && this.$store.state.productdb.find(element => element.바코드 == ele.바코드).구매링크 == '사입'){
                        ele.국내재고수량 = cnt
                        ele.국내재고박스수량 += cnt * vol;
                        krstock += ele.국내재고박스수량;
                        cnt = 0;
                    }
                    if(this.$store.state.stock && this.$store.state.stock.find(element => element.배치발주번호 == e.발주번호 && element.바코드 == ele.바코드)){ ////// -------------------------나중에 삭제
                        ele.국내재고수량 += this.$store.state.stock.filter(element => element.site == 'kr' && element.배치발주번호 == e.발주번호 && element.바코드 == ele.바코드).length
                        if(cnt >= ele.국내재고수량){
                            ele.국내재고박스수량 += ele.국내재고수량 * vol;
                            krstock += ele.국내재고박스수량;
                            cnt -= ele.국내재고수량;
                        } else {
                            ele.국내재고박스수량 += cnt * vol;
                            krstock += ele.국내재고박스수량;
                            cnt = 0;
                        }
                        ele.해외재고수량 += this.$store.state.stock.filter(element => element.site != 'kr' && element.배치발주번호 == e.발주번호 && element.바코드 == ele.바코드).length;
                        if(cnt >= ele.해외재고수량){
                            ele.해외재고박스수량 += ele.해외재고수량 * vol;
                            cnstock += ele.해외재고박스수량;
                            cnt -= ele.해외재고수량;
                        } else {
                            ele.해외재고박스수량 += cnt * vol;
                            cnstock += ele.해외재고박스수량;
                            cnt = 0;
                        }
                    }
                    if(stocks.find(element => element.site == 'kr' && element.바코드 == ele.바코드) && cnt > 0){
                        ele.국내재고수량 += stocks.find(element => element.site == 'kr' && element.바코드 == ele.바코드).수량
                        if(cnt >= ele.국내재고수량){
                            ele.국내재고박스수량 += ele.국내재고수량 * vol;
                            krstock += ele.국내재고박스수량;
                            cnt -= ele.국내재고수량;
                        } else {
                            ele.국내재고박스수량 += cnt * vol;
                            krstock += ele.국내재고박스수량;
                            cnt = 0;
                        }
                    }
                    if(stocks.find(element => element.site == 'cn' && element.바코드 == ele.바코드) && cnt > 0){
                        ele.해외재고수량 += stocks.find(element => element.site == 'cn' && element.바코드 == ele.바코드).수량;
                        if(cnt >= ele.해외재고수량){
                            ele.해외재고박스수량 += ele.해외재고수량 * vol;
                            cnstock += ele.해외재고박스수량;
                            cnt -= ele.해외재고수량;
                        } else {
                            ele.해외재고박스수량 += cnt * vol;
                            cnstock += ele.해외재고박스수량;
                            cnt = 0;
                        }
                    }
                    // rstock += stocks.find(element => element.site == 'kr' && element.바코드 == ele.바코드).수량 * vol;
                    if(stocks.find(element => element.site == 'po' && element.바코드 == ele.바코드) && cnt > 0){
                        ele.구매재고수량 = stocks.find(element => element.site == 'po' && element.바코드 == ele.바코드).수량;
                        if(cnt >= ele.구매재고수량){
                            ele.구매재고박스수량 += ele.구매재고수량 * vol
                            pstock += ele.구매재고박스수량;
                            cnt -= ele.구매재고수량;
                        } else {
                            ele.구매재고박스수량 += cnt * vol;
                            pstock += ele.구매재고박스수량;
                            cnt = 0;
                        }
                    }
                    ele.확정박스수량 += parseInt(ele.확정수량) * vol
                    totalcnt += ele.확정박스수량;

                    stocks = stocks.filter(element => element.바코드 != ele.바코드);
                    ele.등록이미지 = this.$store.state.productdb.find(element => element.바코드 == ele.바코드).등록이미지;

                    if(ele.확정수량 == 0){
                        ele.부피대비수익률 = 0
                    } else {
                        ele.부피대비수익률 = (parseInt(ele.매입가.replace(/,/g, ''))) / vol
                    }
                    ele.부족재고 = cnt;
                    
                })
                e.국내재고박스수량 = krstock;
                e.해외재고박스수량 = cnstock;
                e.구매재고박스수량 = pstock;

                e.총박스수량 = krstock + cnstock + pstock;
                e.총확정박스수량 = totalcnt;
                // e.회송재고박스수량 = rstock;
                
            })
            // console.log(arr)

            //발주내역에서 출고박스리스트 추출
            var oj = {}
            var ojadd = {}
            // var ta
            // var result = [];
            arr.forEach(e => {
                if(this.boxlistsinit.length > 0 && this.boxlistsinit.filter(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).length > 0){
                    ojadd = {
                        발주번호 : e.발주번호,
                        발주세부내역 : e.발주세부내역,
                        발주상태 : e.발주상태,
                        발주운송 : e.발주운송
                    }
                    this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).발주내역.push(ojadd)
                    this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).국내재고박스수량 += e.국내재고박스수량;
                    this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).해외재고박스수량 += e.해외재고박스수량;
                    this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).구매재고박스수량 += e.구매재고박스수량;
                    this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).총박스수량 = this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).국내재고박스수량 + this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).해외재고박스수량 + this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).구매재고박스수량
                    this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).총확정박스수량 += e.총확정박스수량;

                    if(e.발주상태.includes('거래처')){
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).국내재고박스수량_확정전 += e.국내재고박스수량;
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).해외재고박스수량_확정전 += e.해외재고박스수량;
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).구매재고박스수량_확정전 += e.구매재고박스수량;
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).총박스수량_확정전 = this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).국내재고박스수량_확정전 + this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).해외재고박스수량_확정전 + this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).구매재고박스수량_확정전
                    } else {
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).국내재고박스수량_확정후 += e.국내재고박스수량;
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).해외재고박스수량_확정후 += e.해외재고박스수량;
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).구매재고박스수량_확정후 += e.구매재고박스수량;
                        this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).총박스수량_확정후 = this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).국내재고박스수량_확정후 + this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).해외재고박스수량_확정후 + this.boxlistsinit.find(ele => ele.발주센터 == e.발주센터 && ele.입고예정일 == e.입고예정일).구매재고박스수량_확정후
                    }

                } else {
                    oj = {
                        국내재고박스수량 : e.국내재고박스수량,
                        해외재고박스수량 : e.해외재고박스수량,
                        구매재고박스수량 : e.구매재고박스수량,
                        총확정박스수량 : e.총확정박스수량,
                        국내재고박스수량_확정전 : e.발주상태.includes('거래처') ? e.국내재고박스수량 : 0,
                        해외재고박스수량_확정전 : e.발주상태.includes('거래처') ? e.해외재고박스수량 : 0,
                        구매재고박스수량_확정전 : e.발주상태.includes('거래처') ? e.구매재고박스수량 : 0,
                        국내재고박스수량_확정후 : e.발주상태.includes('발주확정') ? e.국내재고박스수량 : 0,
                        해외재고박스수량_확정후 : e.발주상태.includes('발주확정') ? e.해외재고박스수량 : 0,
                        구매재고박스수량_확정후 : e.발주상태.includes('발주확정') ? e.구매재고박스수량 : 0,                                          
                        발주내역 : [{
                            발주번호 : e.발주번호,
                            발주세부내역 : e.발주세부내역,
                            발주상태 : e.발주상태,
                            발주운송 : e.발주운송,
                            reason: '협력사 재고부족 - 수요예측 오류',
                            logistics: '쉽먼트'                            
                        }],
                        총박스수량 : e.총박스수량,
                        총박스수량_확정전 : e.발주상태.includes('거래처') ? e.총박스수량 : 0,
                        총박스수량_확정후 : e.발주상태.includes('발주확정') ? e.총박스수량 : 0,
                        발주센터 : e.발주센터,
                        입고예정일 : e.입고예정일,
                        confirmpo : 'all',
                    }

                    // if(e.총박스수량 > 0){
                        this.boxlistsinit.push(oj)
                    // }
                }
            })
            this.boxlistsinit.forEach(e => {
                oj.boxdetailinit = this.openconfirmpo(e);
                oj.boxdetail = JSON.parse(JSON.stringify(oj.boxdetailinit)).filter(e => e.발주운송 === '쉽먼트');
                oj.milkrundetail = JSON.parse(JSON.stringify(oj.boxdetailinit)).filter(e => e.발주운송 !== '쉽먼트');
                this.boxlists.push(this.deepClone(e))
            })
            setTimeout(() => {
                this.$bvModal.show('confirmmodal')
            },50)
        },
        openconfirmpo(list){
            var obj = {}
            var arr = [];
            var boxdetailinit = [];

            list.발주내역.forEach(e => {
                e.발주세부내역.forEach(ele => {
                    obj = {
                        발주번호 : e.발주번호,
                        발주센터 : list.발주센터,
                        발주상태 : e.발주상태,
                        발주운송 : e.발주운송,
                        입고예정일 : list.입고예정일,
                        상품명 : ele.상품명,
                        SKUID : ele.SKUID,
                        바코드 : ele.바코드,
                        등록이미지 : ele.등록이미지,
                        국내재고수량 : ele.국내재고수량,
                        해외재고수량 : ele.해외재고수량,
                        구매재고수량 : ele.구매재고수량,
                        부피대비수익률 : this.confirmpo == 'all' ? ele.부피대비수익률 : ele.국내재고박스수량 + ele.해외재고박스수량 + ele.구매재고박스수량 == 0 ? 0 : ele.부피대비수익률,
                        '1박스인입수량':ele['1박스인입수량'],
                        박스수량 : this.confirmpo == 'all' ? ele.확정박스수량 : ele.국내재고박스수량 + ele.해외재고박스수량 + ele.구매재고박스수량,
                        확정수량 : parseInt(ele.확정수량),
                        발주수량 : parseInt(ele.발주수량)
                    }
                    // if(obj.부피대비수익률 > 0 && obj.확정수량 > 0){
                        arr.push(obj)
                    // }
                })
            })
            console.log(arr)
            

            arr.sort(function(a,b){
                if (a.부피대비수익률 < b.부피대비수익률){
                    return 1;
                }
                if (a.부피대비수익률 > b.부피대비수익률){
                    return -1;
                }
                return 0;
            })
            
            var copyobj = {};
            var i
            var totalkr
            var totalcn
            var totalpu
            var kr
            var cn
            var pu
            var boxqty
            var totalqty
            arr.forEach(e => {
                if(e.박스수량 > 1){
                    boxqty = e.박스수량;
                    totalqty = e.확정수량;
                    totalkr = e.국내재고수량;
                    totalcn = e.해외재고수량;
                    totalpu = e.구매재고수량;
                    for(i=0;i<e.박스수량;i++){ 
                        if(boxqty > 1){
                            if(totalkr >= e['1박스인입수량']){
                                kr = e['1박스인입수량'];
                                cn = 0;
                                pu = 0;
                            } else {
                                if(totalkr + totalcn >= e['1박스인입수량']){
                                    kr = totalkr;
                                    cn = e['1박스인입수량'] - totalkr;
                                    pu = 0;
                                } else {
                                    if(totalkr + totalcn + totalpu >= e['1박스인입수량']){
                                        kr = totalkr;
                                        cn = totalcn;
                                        pu = e['1박스인입수량'] - totalkr - totalcn;
                                    } else {
                                        kr = totalkr;
                                        cn = totalcn;
                                        pu = totalpu;
                                    }
                                }
                            }
                            copyobj = {
                                checked : false,
                                발주번호 : e.발주번호,
                                발주센터 : e.발주센터,
                                발주상태 : e.발주상태,
                                발주운송 : e.발주운송,
                                입고예정일 : e.입고예정일,
                                상품명 : e.상품명,
                                SKUID : e.SKUID,
                                바코드 : e.바코드,
                                등록이미지 : e.등록이미지,
                                국내재고수량 : kr,
                                해외재고수량 : cn,
                                구매재고수량 : pu,
                                부피대비수익률 : e.부피대비수익률,
                                '1박스인입수량':e['1박스인입수량'],
                                박스수량 : 1,
                                확정수량 : e['1박스인입수량'],
                                발주수량 : e.발주수량,
                                showchangedb : true,
                            }
                            

                            boxdetailinit.push(this.deepClone(copyobj))
                            boxqty--
                            totalqty -= e['1박스인입수량'];
                            totalkr -= kr;
                            totalcn -= cn;
                            totalpu -= pu;
                            
                        } else {
                            if(totalkr >= e['1박스인입수량']){
                                kr = e['1박스인입수량'];
                                cn = 0;
                                pu = 0;
                            } else {
                                if(totalkr + totalcn >= e['1박스인입수량']){
                                    kr = totalkr;
                                    cn = e['1박스인입수량'] - totalkr;
                                    pu = 0;
                                } else {
                                    if(totalkr + totalcn + totalpu >= e['1박스인입수량']){
                                        kr = totalkr;
                                        cn = totalcn;
                                        pu = e['1박스인입수량'] - totalkr - totalcn;
                                    } else {
                                        kr = totalkr;
                                        cn = totalcn;
                                        pu = totalpu;
                                    }
                                }
                            }
                            copyobj = {
                                checked : false,
                                발주번호 : e.발주번호,
                                발주센터 : e.발주센터,
                                발주상태 : e.발주상태,
                                발주운송 : e.발주운송,
                                입고예정일 : e.입고예정일,
                                상품명 : e.상품명,
                                SKUID : e.SKUID,
                                바코드 : e.바코드,
                                등록이미지 : e.등록이미지,
                                국내재고수량 : kr,
                                해외재고수량 : cn,
                                구매재고수량 : pu,
                                부피대비수익률 : e.부피대비수익률,
                                '1박스인입수량':e['1박스인입수량'],
                                박스수량 : boxqty,
                                확정수량 : totalqty,
                                발주수량 : e.발주수량,
                                showchangedb : true,
                            }
                            

                            boxdetailinit.push(this.deepClone(copyobj))
                           
                        }
                    }
                } else {
                    totalkr = e.국내재고수량;
                    totalcn = e.해외재고수량;
                    totalpu = e.구매재고수량;
                    if(totalkr >= e.확정수량){
                        kr = e.확정수량;
                        cn = 0;
                        pu = 0;
                    } else {
                        if(totalkr + totalcn >= e.확정수량){
                            kr = totalkr;
                            cn = e.확정수량 - totalkr;
                            pu = 0;
                        } else {
                            if(totalkr + totalcn + totalpu >= e.확정수량){
                                kr = totalkr;
                                cn = totalcn;
                                pu = e.확정수량 - totalkr - totalcn;
                            } else {
                                kr = totalkr;
                                cn = totalcn;
                                pu = totalpu;
                            }
                        }
                    }
                    copyobj = {
                        checked : false,
                        발주번호 : e.발주번호,
                        발주센터 : e.발주센터,
                        발주상태 : e.발주상태,
                        발주운송 : e.발주운송,
                        입고예정일 : e.입고예정일,
                        상품명 : e.상품명,
                        SKUID : e.SKUID,
                        바코드 : e.바코드,
                        등록이미지 : e.등록이미지,
                        국내재고수량 : kr,
                        해외재고수량 : cn,
                        구매재고수량 : pu,
                        부피대비수익률 : e.부피대비수익률,
                        '1박스인입수량':e['1박스인입수량'],
                        박스수량 : e.박스수량,
                        확정수량 : e.확정수량,
                        발주수량 : e.발주수량,
                        showchangedb : true,
                    }
                    boxdetailinit.push(this.deepClone(copyobj))
                }
            })
            var box = this.sortbox(boxdetailinit,list);
            return box
        },
        sortbox(boxdetail,list){
            var n = 0
            if(list.confirmpo == 'all'){
                boxdetail.sort(function(a,b){
                    if (a.확정수량 < b.확정수량){
                        return 1;
                    }
                    if (a.확정수량 > b.확정수량){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.부피대비수익률 < b.부피대비수익률){
                        return 1;
                    }
                    if (a.부피대비수익률 > b.부피대비수익률){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.해외재고수량 == 0 && b.해외재고수량 > 0 || a.국내재고수량 == 0 && b.국내재고수량 > 0 || a.구매재고수량 == 0 && b.구매재고수량 > 0){
                        return 1;
                    }
                    if (a.해외재고수량 > 0 && b.해외재고수량 == 0 || a.국내재고수량 > 0 && b.국내재고수량 == 0 || a.구매재고수량 > 0 && b.구매재고수량 == 0){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.확정수량 == 0 && b.확정수량 > 0){
                        return 1;
                    }
                    if (a.확정수량 > 0 && b.확정수량 == 0){
                        return -1;
                    }
                    return 0;
                })                

                boxdetail.forEach(e => {
                    n += e.박스수량;
                    e.누적박스수량 = n;
                    e.출고박스번호 = Math.ceil(e.누적박스수량);
                })
            }            
            if(list.confirmpo == 'total'){
                boxdetail.sort(function(a,b){
                    if (a.확정수량 < b.확정수량){
                        return 1;
                    }
                    if (a.확정수량 > b.확정수량){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.부피대비수익률 < b.부피대비수익률){
                        return 1;
                    }
                    if (a.부피대비수익률 > b.부피대비수익률){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.forEach(e => {
                    n += e.박스수량;
                    e.누적박스수량 = n;
                    e.출고박스번호 = Math.ceil(e.누적박스수량);
                })
            }
            if(list.confirmpo == 'stockkr'){
                boxdetail.sort(function(a,b){
                    if (a.확정수량 < b.확정수량){
                        return 1;
                    }
                    if (a.확정수량 > b.확정수량){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.부피대비수익률 < b.부피대비수익률){
                        return 1;
                    }
                    if (a.부피대비수익률 > b.부피대비수익률){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.국내재고수량 == 0 && b.국내재고수량 > 0){
                        return 1;
                    }
                    if (a.국내재고수량 > 0 && b.국내재고수량 == 0){
                        return -1;
                    }
                    return 0;
                })                
                boxdetail.forEach(e => {
                    n += e.박스수량;
                    e.누적박스수량 = n;
                    e.출고박스번호 = Math.ceil(e.누적박스수량);
                })
            }
            if(list.confirmpo == 'stocktotal'){
                boxdetail.sort(function(a,b){
                    if (a.확정수량 < b.확정수량){
                        return 1;
                    }
                    if (a.확정수량 > b.확정수량){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.부피대비수익률 < b.부피대비수익률){
                        return 1;
                    }
                    if (a.부피대비수익률 > b.부피대비수익률){
                        return -1;
                    }
                    return 0;
                })
                boxdetail.sort(function(a,b){
                    if (a.해외재고수량 == 0 && b.해외재고수량 > 0 || a.국내재고수량 == 0 && b.국내재고수량 > 0){
                        return 1;
                    }
                    if (a.해외재고수량 > 0 && b.해외재고수량 == 0 || a.국내재고수량 > 0 && b.국내재고수량 == 0){
                        return -1;
                    }
                    return 0;
                })             
                boxdetail.forEach(e => {
                    n += e.박스수량;
                    e.누적박스수량 = n;
                    e.출고박스번호 = Math.ceil(e.누적박스수량);
                })
            }   
            boxdetail.sort(function(a,b){
                if (a.발주운송 == "쉽먼트" && b.발주운송 != '쉽먼트'){
                    return 1;
                }
                if (a.발주운송 != "쉽먼트" && b.발주운송 == '쉽먼트'){
                    return -1;
                }
                return 0;
            })
            return boxdetail            
        },
        styleobj(a){
            if(a.minus){
                return {background: '#FFC0CB'}
            }
        },

        // 검색 핸들러 (통합) - 검색 조건에 따라 자동 뷰 전환
        async handleSearch() {
            // 원가표가 아직 안 들어왔으면 기다린다. mounted의 다른 조회(Purchase 등)가 길어서
            // 그 사이에 검색을 누르면 원가 없이 계산돼 수익 3개가 0원으로 남는다
            if (this.importPricesPromise) await this.importPricesPromise;

            // SKU ID나 바코드로 검색 시 → SKU 기준 뷰로 자동 전환
            if (this.SKUID.length > 0 || this.바코드.length > 0) {
                this.searchMode = 'sku';
                this.viewMode = 'sku';
                this.showtable = false;
                this.showdetailtable = true;
            } else {
                // 발주번호 검색 또는 기간 검색 → 발주서 기준
                this.searchMode = 'po';
                this.viewMode = 'po';
                this.showtable = true;
                this.showdetailtable = false;
            }

            // 검색 범위가 Vuex에 저장된 범위를 벗어나면 API 호출
            if (!this.isSearchRangeWithinVuex()) {
                this.showspinner = true;
                this.isDataLoading = true;
                this.loadingProgress = '발주서 데이터 검색 중...';

                try {
                    const res = await axios.post('/api/getPolist', {
                        startdate: this.startdate,
                        enddate: this.enddate,
                        selectoption: this.selectoption
                    });

                    if (res.data.success) {
                        this.$store.commit('polistupdate', {
                            data: res.data.data,
                            dateRange: { startdate: this.startdate, enddate: this.enddate }
                        });
                        console.log('[listcategory] 검색 범위 API 호출:', res.data.data.length, '개');
                    } else {
                        alert('발주서 데이터 조회 실패: ' + (res.data.message || ''));
                        this.showspinner = false;
                        this.isDataLoading = false;
                        return;
                    }
                } catch (error) {
                    console.error('[listcategory] API 호출 오류:', error);
                    alert('발주서 데이터 조회 중 오류가 발생했습니다.');
                    this.showspinner = false;
                    this.isDataLoading = false;
                    return;
                } finally {
                    this.isDataLoading = false;
                    this.loadingProgress = '';
                }
            }

            this.search(this.viewMode === 'po');
        },

        // 뷰 모드 스위칭 (버튼에서 호출)
        switchViewMode(mode) {
            this.viewMode = mode;
            // 전환 시 필터 초기화
            this.selectedPoFilter = null;
            this.selectedSkuFilter = null;
            this.polists = this.searchresult;

            if (this.viewMode === 'po') {
                this.showtable = true;
                this.showdetailtable = false;
            } else {
                this.showtable = false;
                this.showdetailtable = true;
            }
            // SKU 기준 보기일 때 skuItems 생성
            if (mode === 'sku' && this.searchresult.length > 0) {
                this.generateSkuItems();
            }
        },

        // 발주 상세 모달 열기
        openPoDetailModal(item) {
            this.selectedPoForModal = item;
            this.$bvModal.show('po-detail-modal');
        },

        // SKU 기준 데이터 생성 (SKU ID/바코드 검색 시 필터링)
        generateSkuItems() {
            const items = [];
            const searchSkuId = this.SKUID.trim();
            const searchBarcode = this.바코드.trim();

            // SKU 기준 통계 초기화
            this.skuTotalAmount = 0;
            this.skuTotalCancelAmount = 0;
            this.skuTotalQty = 0;
            this.skuConfirmQty = 0;
            this.skuTotalProfit = 0;

            this.polists.forEach(po => {
                if (po.발주세부내역 && po.발주세부내역.length > 0) {
                    po.발주세부내역.forEach(sku => {
                        // SKU 검색 모드일 때 필터링
                        if (this.searchMode === 'sku') {
                            // SKU ID 검색 조건 (문자열/숫자 타입 무관하게 비교)
                            if (searchSkuId.length > 0 && String(sku.SKUID) !== searchSkuId) {
                                return; // 해당 SKU 제외
                            }
                            // 바코드 검색 조건
                            if (searchBarcode.length > 0 && String(sku.바코드) !== searchBarcode) {
                                return; // 해당 SKU 제외
                            }
                        }

                        // SKU별 금액 계산 (매입가 * 발주수량) - 여기서 매입가는 쿠팡 공급가
                        const 공급가숫자 = parseInt((sku.매입가 || '0').toString().replace(/,/g, '')) || 0;
                        const 금액숫자 = 공급가숫자 * sku.발주수량;
                        const 금액 = 금액숫자.toLocaleString();

                        // 원가(우리 매입가) 조회 및 수익 계산
                        const 원가 = this.getImportPrice(sku.바코드);
                        const 단위수익 = (공급가숫자 > 0 && 원가 > 0) ? Math.round((공급가숫자 - 원가) * 10 / 11) : 0;
                        const 수익 = po.발주상태 !== '발주취소' ? 단위수익 * (sku.발주수량 || 0) : 0;

                        // SKU 기준 통계 누적
                        this.skuTotalQty += sku.발주수량;
                        this.skuConfirmQty += sku.확정수량;
                        if (po.발주상태 === '발주취소') {
                            this.skuTotalCancelAmount += 금액숫자;
                        } else {
                            this.skuTotalAmount += 금액숫자;
                            this.skuTotalProfit += 수익;
                        }

                        items.push({
                            발주번호: po.발주번호,
                            발주상태: po.발주상태,
                            발주일시: po.발주일시,
                            발주센터: po.발주센터,
                            입고예정일: po.입고예정일,
                            SKUID: sku.SKUID,
                            상품명: sku.상품명,
                            IMGURL: sku.IMGURL,
                            바코드: sku.바코드,
                            발주수량: sku.발주수량,
                            확정수량: sku.확정수량,
                            배치수량: sku.배치수량,
                            미배치재고수량: sku.미배치재고수량,
                            구매필요수량: sku.구매필요수량,
                            구매완료수량: sku.구매완료수량,
                            회송예정수량: sku.회송예정수량,
                            사입재고수량: sku.사입재고수량,
                            매입가: sku.매입가,
                            공급가: sku.공급가,
                            금액: 금액,
                            수익: 수익 > 0 ? 수익.toLocaleString() : '-',
                            _id: `${po.발주번호}-${sku.SKUID}-${sku.바코드}`
                        });
                    });
                }
            });
            this.skuItems = items;
        },

        search(bool){
            console.log(this.$store.state.polist.find(e => e.발주번호 == "99458684"))
            this.showspinner = true;
            this.totalpo = 0;
            this.totalcancel = 0;
            if(bool){
                this.showtable = true;
                this.showdetailtable = false;
            } else {
                this.showtable = false;
                this.showdetailtable = true;
            }
            setTimeout(() => {
                this.showlist = false;
                this.polists = [];
                if(this.$store.state.polist.length > 0){
                setTimeout(() => {
                    var arr = [];
                    var arrangecnt = 0;
                    var notarrangecnt = 0;
                    var overseascnt = 0;
                    var domesticcnt = 0;
                    var pstockcnt = 0;
                    var rstockcnt = 0;
                    if(this.selectoption == '발주일'){
                        this.polists = this.$store.state.polist.filter(e => this.timestamp(this.startdate) <= this.timestamp(e.발주일시.slice(0,10)) && this.timestamp(this.enddate + "T23:59:59") >= this.timestamp(e.발주일시.slice(0,10)));
                    } else {
                        this.polists = this.$store.state.polist.filter(e => this.timestamp(this.startdate) <= this.timestamp(e.입고예정일.slice(0,10)) && this.timestamp(this.enddate + "T23:59:59") >= this.timestamp(e.입고예정일.slice(0,10)));
                    }
                    this.polists.forEach(e => {
                        e.발주세부내역.forEach(ele => {
                            arrangecnt = 0;
                            notarrangecnt = 0;
                            overseascnt = 0;
                            domesticcnt = 0;
                            pstockcnt = 0;
                            rstockcnt = 0;
                            if (this.$store.state.stock.length != 0){
                                this.$store.state.stock.forEach(element => {
                                    if(element.바코드 == ele.바코드){
                                        if(ele.바코드 == 'R009851590039'){
                                            console.log(element)
                                        }
                                        if(element.배치발주번호 == e.발주번호){
                                            arrangecnt++
                                        } else {
                                            if(element.배치발주번호 == ''){
                                                if(element.stockinfo == 'stock') {
                                                    if(parseInt(ele.확정수량.toString().replaceAll(',','')) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt > 0){
                                                        
                                                        if(element.site == 'cn'){
                                                            overseascnt++
                                                            notarrangecnt++
                                                        } else {
                                                            if(element.site == 'kr'){
                                                                domesticcnt++
                                                                notarrangecnt++
                                                            }
                                                        }
                                                    }
                                                } else {
                                                    if(element.stockinfo == 'Pstock') {
                                                        pstockcnt++
                                                    } else {
                                                        if(element.stockinfo == 'Rstock') {
                                                            if(parseInt(ele.확정수량.toString().replaceAll(',','')) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt > 0){
                                                                rstockcnt++
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                })
                            }
                            
                            ele.발주수량 = parseInt(ele.발주수량.toString().replaceAll(',',''));
                            ele.입고수량 = parseInt(ele.입고수량.toString().replaceAll(',',''));
                            if(isNaN(ele.입고수량)){
                                ele.입고수량 = 0;
                            }
                            ele.확정수량 = parseInt(ele.확정수량.toString().replaceAll(',',''));
                            ele.배치수량 = arrangecnt;
                            ele.미배치재고수량 = notarrangecnt;
                            ele.국내재고 = domesticcnt;
                            ele.해외재고 = overseascnt;
                            ele.구매완료수량 = pstockcnt;
                            ele.회송예정수량 = rstockcnt;
                            ele.사입재고수량 = 0;
                            if(ele.바코드 == 'R009851590039'){
                                console.log(ele)
                            }
                            if(ele.확정수량 - arrangecnt - notarrangecnt - pstockcnt - rstockcnt > 0){
                                this.$store.state.productdb.some(element => {
                                    if(ele.바코드 == element.바코드 && element.구매링크 == '사입'){
                                        ele.사입재고수량 = ele.확정수량 - arrangecnt - notarrangecnt - pstockcnt - rstockcnt;
                                        return (ele.바코드 == element.바코드 && element.구매링크 == '사입')
                                    }
                                })
                            }
                            ele.구매필요수량 = ele.확정수량 - arrangecnt - notarrangecnt - pstockcnt - rstockcnt - ele.사입재고수량;
                            // console.log(this.$store.state.productdb.find(element => element.바코드 == ele.바코드))
                            // console.log(ele.바코드)
                            // console.log(e.발주번호)
                            if(this.$store.state.productdb.find(element => element.바코드 == ele.바코드) && this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가){
                                ele.공급가 = this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가
                            } else {
                                ele.공급가 = 0
                            }
                            
                        })
                    })

                    // 발주서별 발주수량, 확정수량, 수익 합계 계산
                    this.polists.forEach(e => {
                        let totalQty = 0;
                        let confirmQty = 0;
                        let poProfit = 0;
                        e.발주세부내역.forEach(ele => {
                            totalQty += ele.발주수량 || 0;
                            confirmQty += ele.확정수량 || 0;
                            // 수익 계산: (공급가 - 원가) * 10/11 * 수량
                            if (e.발주상태 !== '발주취소') {
                                const 공급가 = parseInt((ele.매입가 || '0').toString().replace(/,/g, '')) || 0;
                                const 원가 = this.getImportPrice(ele.바코드);
                                if (공급가 > 0 && 원가 > 0) {
                                    poProfit += Math.round((공급가 - 원가) * 10 / 11) * (ele.발주수량 || 0);
                                }
                            }
                        });
                        e.발주수량 = totalQty;
                        e.확정수량 = confirmQty;
                        e.수익 = poProfit > 0 ? poProfit.toLocaleString() : '-';
                    });

                    this.polists.sort(function(a,b){
                        if (a.발주일시 < b.발주일시){
                            return 1;
                        }
                        if (a.발주일시 > b.발주일시){
                            return -1;
                        }
                        return 0;
                    })
                    // console.log(this.발주번호.length)
                    
                    if (this.발주번호.length > 0) {
                        this.polists.forEach((e,i) => {
                            if(e.발주번호 == this.발주번호){
                                arr.push(e)
                            }
                            if(i == this.polists.length - 1){
                                this.polists = arr;
                                this.발주번호 = '';
                            }
                        })
                    } else {
                        if (this.SKUID.length > 0) {
                            this.polists.forEach((e,i) => {
                                e.발주세부내역.forEach(ele => {
                                    if(ele.SKUID == this.SKUID){
                                        arr.push(e)
                                    }
                                    if(i == this.polists.length - 1){
                                        this.polists = arr;
                                        this.SKUID = '';
                                    }                                
                                })
                            })
                        } else {
                            if (this.바코드.length > 0) {
                                this.polists.forEach((e,i) => {
                                    e.발주세부내역.forEach(ele => {
                                        if(ele.바코드 == this.바코드){
                                            arr.push(e)                              
                                        }
                                        if(i == this.polists.length - 1){
                                            this.polists = arr;
                                            this.바코드 = '';
                                        }                                 
                                    })
                                })
                            }
                        }
                    }

                    // if(this.checksstock){
                    //     this.polists = this.polists.filter(e => e.발주세부내역.some(ele => ele.사입재고수량 > 0));
                    // }

                    //모니터링
                    this.mototal = 0;
                    this.mostock = 0;
                    this.moconfirm = 0;
                    this.moaddstock = 0;
                    this.moastock = 0;
                    this.mopstock = 0;
                    this.morstock = 0;
                    this.mosstock = 0;
                    this.minusprofit = 0;
                    this.mocancel = 0;
                    this.totalProfit = 0;
                    this.moReceivedQty = 0;
                    this.orderProfit = 0;
                    this.confirmProfit = 0;
                    this.receivedProfit = 0;
                    this.missingImportPriceCount = 0;
                    var missingBarcodes = new Set();
                    this.polists.forEach(e => {
                        this.totalpo += parseInt(e.금액.replaceAll(',',''))
                        if(e.발주상태 == '발주취소'){
                            this.totalcancel += parseInt(e.금액.replaceAll(',',''))
                        }
                        e.발주세부내역.forEach(ele => {
                            this.mototal += ele.발주수량;
                            this.moReceivedQty += ele.입고수량 || 0;
                            if(e.발주상태 == '발주취소'){
                                this.mocancel += ele.발주수량;
                            } else {
                                this.moconfirm += ele.확정수량;
                                this.mostock += ele.미배치재고수량;
                                this.moaddstock += ele.구매필요수량;
                                this.moastock += ele.배치수량;
                                this.mopstock += ele.구매완료수량;
                                this.morstock += ele.회송예정수량;
                                this.mosstock += ele.사입재고수량;
                                const 공급가 = parseInt((ele.매입가 || '0').toString().replace(/,/g, '')) || 0;
                                const 원가 = this.getImportPrice(ele.바코드);
                                if (공급가 > 0 && 원가 === 0 && !missingBarcodes.has(ele.바코드)) {
                                    missingBarcodes.add(ele.바코드);
                                }
                                if (공급가 > 0 && 원가 > 0) {
                                    const 단위수익 = Math.round((공급가 - 원가) * 10 / 11);
                                    this.orderProfit += 단위수익 * (ele.발주수량 || 0);
                                    this.confirmProfit += 단위수익 * (ele.확정수량 || 0);
                                    this.receivedProfit += 단위수익 * (ele.입고수량 || 0);
                                }
                                if(this.$store.state.productdb.find(element => element.바코드 == ele.바코드)){
                                    if(parseInt(ele.매입가.replaceAll(",","")) < parseInt(this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가)){
                                        this.minusprofit++
                                    }
                                }

                            }
                        })
                    })
                    this.totalProfit = this.orderProfit;
                    this.missingImportPriceCount = missingBarcodes.size;
                    this.buildDailyChart();

                    this.searchresult = this.polists;

                    // SKU 기준 데이터 생성
                    this.generateSkuItems();

                    //console.log(this.polists)
                    this.showlist = true;
                }, 1);
                } else {
                    alert('발주내역이 없습니다.')
                }
                this.showspinner = false;
            }, 1);

        },
        showmototal(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult
                this.showlist = true;
            }, 1);
        },
        minusprofitlist(){
            this.showlist = false;
            setTimeout(() => {
                
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => parseInt(ele.매입가.replaceAll(",","")) < parseInt(this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가)));
                this.polists.forEach(e => {
                    e.발주세부내역.forEach(ele => {
                        if(parseInt(ele.매입가.replaceAll(",","")) < parseInt(this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가)){
                            console.log(this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가)
                            console.log(parseInt(this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가))
                            console.log(ele.매입가.replaceAll(",",""))
                            console.log(parseInt(ele.매입가.replaceAll(",","")))
                            ele.minus = parseInt(this.$store.state.productdb.find(element => element.바코드 == ele.바코드).매입가) - parseInt(ele.매입가.replaceAll(",",""));
                            console.log(ele.minus)
                        }
                    })
                })
                console.log(this.polists)
                this.showlist = true;
            }, 1); 
        }, 
        showmocancel(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주상태 == '발주취소');
                this.showlist = true;
            }, 1);
        },     
        showmosstock(){
            this.showlist=false;
            setTimeout(() => {
                
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.사입재고수량 > 0));
                this.showlist = true;
            }, 1);
        },
        showmostock(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.미배치재고수량 > 0));
                this.showlist = true;
            }, 1);
        },
        showmoconfirm(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.확정수량 > 0));
                this.showlist = true;
            }, 1);
        },
        showmoaddstock(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.구매필요수량 > 0));
                this.showlist = true;
            }, 1);
        },
        showmoastock(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.배치수량 > 0));
                this.showlist = true;
            }, 1);
        }, 
        showmopstock(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.구매완료수량 > 0));
                this.showlist = true;
            }, 1);
        }, 
        showmorstock(){
            this.showlist=false;
            setTimeout(() => {
                this.polists = this.searchresult.filter(e => e.발주세부내역.some(ele => ele.회송예정수량 > 0));
                this.showlist = true;
            }, 1);
        }, 
		deepClone(obj) {
			if (obj === null || typeof obj !== "object") {
				return obj
			}

			const result = Array.isArray(obj) ? [] : {}

			for (let key of Object.keys(obj)) {
				result[key] = this.deepClone(obj[key])
			}

			return result
		},        
        timestamp(date){
            //inputdate = "yyyy-mm-dd"
            return new Date(date).getTime() / 1000
        },
        getTodaywith(){
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },   
        getdate(timestamp){
            var date = new Date(timestamp);
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },              
        MenuUpdate() {
            console.log(this.picked)
            if (this.picked == "radio1") {
                this.menuint = this.menuDefault;
            } else {
                if (this.picked == "radio2") {
                    this.menuint = this.menuDetail;
                } else {
                    this.menuint = this.menuSales;
                }
            }
        },
        MenuUpdate1() {
            console.log(this.picked1)
            if (this.picked1 == "radio1") {
                this.showdetailtable = false;
                this.showtable = true;
            } else {
                this.showdetailtable = true;
                this.showtable = false;
            }
        },
        changedate(){
            var now
            var target
            if(this.selectdate == 'today'){
                this.startdate = this.getTodaywith();
                this.enddate = this.getTodaywith();
            } else {
                if(this.selectdate == 'week'){
                    now = new Date(this.getTodaywith());
                    target = now - 1000*60*60*24*7
                    
                    this.startdate = this.getdate(target);
                    this.enddate = this.getTodaywith();
                } else {
                    if(this.selectdate == 'month'){
                    now = new Date(this.getTodaywith());
                    target = now - 1000*60*60*24*30
                    this.startdate = this.getdate(target);
                    this.enddate = this.getTodaywith();
                    }
                }
            }
        },
        modalID(index) {
            // console.log(index);
            return 'modal' + index
        },
        // test(index) {
        //     // console.log(index)
        //     // console.log(this.modalID(index))
        // },
        downloadpolist() {
            function getToday(){
                var date = new Date();
                var year = date.getFullYear();
                var month = ("0" + (1 + date.getMonth())).slice(-2);
                var day = ("0" + date.getDate()).slice(-2);

                return year + month + day;
            }
            var detailpolists = [];
            var n = 0;
            function mergeObj(obj1, obj2) {
                const newObj = {};
                for (let att in obj1) { 
                    newObj[att] = obj1[att]; 
                }
                for(let att in obj2)  {
                    newObj[att] = obj2[att];
                }
                return newObj;
            }

            // console.log(this.polists.filter(e => e.발주번호 == '44269950'))
            for (let i=0;i<this.polists.length;i++) {
                for (let j=0;j<this.polists[i].발주세부내역.length;j++) {
                    var a = this.polists[i];
                    var b = a.발주세부내역[j];
                    // console.log(a)
                    // console.log(b)
                    detailpolists[n] = mergeObj(a,b);
                    if(detailpolists[n].발주번호 == '44269950'){
                        console.log(detailpolists[n])
                    }
                    n++
                }
            }

            const workBook = XLSX.utils.book_new()
            const workSheet1 = XLSX.utils.json_to_sheet(this.polists)
            const workSheet2 = XLSX.utils.json_to_sheet(detailpolists)
            XLSX.utils.book_append_sheet(workBook, workSheet1, '발주내역')
            XLSX.utils.book_append_sheet(workBook, workSheet2, '발주세부내역')
            XLSX.writeFile(workBook, '발주내역' + '_' + getToday() + '.xlsx')
        },
        downloadpoconfirm(){
            if(this.polists.filter(e => e.발주상태 == '거래처확인요청').length == 0){
                alert('다운로드할 내역이 없습니다.')
                return
            }
            var detailpolists = [];
            var n = 0;
            function mergeObj(obj1, obj2) {
                const newObj = {};
                for (let att in obj1) { 
                    newObj[att] = obj1[att]; 
                }
                for(let att in obj2)  {
                    newObj[att] = obj2[att];
                }
                return newObj;
            }

            for (let i=0;i<this.polists.length;i++) {
                for (let j=0;j<this.polists[i].발주세부내역.length;j++) {
                    var a = this.polists[i];
                    var b = a.발주세부내역[j];
                    // console.log(a)
                    // console.log(b)
                    detailpolists[n] = mergeObj(a,b);
                    n++
                }
            }

            // console.log(detailpolists)

            var arr = detailpolists.filter(e => e.발주상태 == "거래처확인요청")
            var ar = [];
            var obj= {};
            var confirmcnt = 0;
            if(this.confirmpo == 'total'){
                arr.forEach(e => {
                    obj = {
                        발주번호 : e.발주번호,
                        물류센터 : e.발주센터,
                        입고유형 : e.발주운송,
                        발주상태 : e.발주상태,
                        상품번호 : e.SKUID,
                        상품바코드 : e.바코드,
                        상품이름 : e.상품명,
                        발주수량 : e.발주수량,
                        확정수량 : e.확정수량,
                        유통기한 : '',
                        제조일자 : '',
                        생산년도 : '',
                        납품부족사유 : this.reason,
                    }
                    ar.push(obj)
                })
            } else {
                if(this.confirmpo == 'stockkr'){
                    arr.forEach(e => {
                        if(e.발주수량 > this.$store.state.stock.filter(ele => ele.바코드 == e.바코드 && ele.stockinfo == 'stock' && ele.site == 'kr').length){
                            confirmcnt = this.$store.state.stock.filter(ele => ele.바코드 == e.바코드 && ele.stockinfo == 'stock' && ele.site == 'kr').length;
                        } else {
                            confirmcnt = e.발주수량;
                        }
                        obj = {
                            발주번호 : e.발주번호,
                            물류센터 : e.발주센터,
                            입고유형 : e.발주운송,
                            발주상태 : e.발주상태,
                            상품번호 : e.SKUID,
                            상품바코드 : e.바코드,
                            상품이름 : e.상품명,
                            발주수량 : e.발주수량,
                            확정수량 : confirmcnt,
                            유통기한 : '',
                            제조일자 : '',
                            생산년도 : '',
                            납품부족사유 : this.reason,
                        }
                        ar.push(obj)
                    })
                } else {
                    arr.forEach(e => {
                        if(e.발주수량 > this.$store.state.stock.filter(ele => ele.바코드 == e.바코드 && ele.stockinfo == 'stock').length){
                            confirmcnt = this.$store.state.stock.filter(ele => ele.바코드 == e.바코드 && ele.stockinfo == 'stock').length;
                        } else {
                            confirmcnt = e.발주수량;
                        }
                        obj = {
                            발주번호 : e.발주번호,
                            물류센터 : e.발주센터,
                            입고유형 : e.발주운송,
                            발주상태 : e.발주상태,
                            상품번호 : e.SKUID,
                            상품바코드 : e.바코드,
                            상품이름 : e.상품명,
                            발주수량 : e.발주수량,
                            확정수량 : confirmcnt,
                            유통기한 : '',
                            제조일자 : '',
                            생산년도 : '',
                            납품부족사유 : this.reason,
                        }
                        ar.push(obj)
                    })
                }
            }

            const workBook = XLSX.utils.book_new()
            const workSheet1 = XLSX.utils.json_to_sheet(ar)
            XLSX.utils.book_append_sheet(workBook, workSheet1, '상품목록')
            XLSX.writeFile(workBook, 'PO_FOR_CONFIRM.xlsx')


        }
    }
}
</script>
<style>
.filter-autocomplete {
    min-width: 180px;
}
.filter-autocomplete .v-input__slot {
    min-height: 32px !important;
    padding: 0 8px !important;
}
.filter-autocomplete .v-label {
    font-size: 0.85rem;
    top: 6px !important;
}
.filter-autocomplete .v-select__selection {
    font-size: 0.85rem;
}

.modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
/* ::v-deep .modal-class {
    max-width: 100%;
    position: absolute; 
    
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
} */


.table .fixed-header {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.table .fixed-header thead {
  display: block;
}

.table .fixed-header tbody {
  display: block;
  height: 800px; /* 테이블 본문의 최대 높이를 지정하세요 */
  overflow-y: scroll; /* 세로 스크롤을 표시할지 여부를 설정하세요 */
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.loading-content {
    text-align: center;
    color: white;
}
</style>

